/* Generated by ai2react v0.102.0 - 2021-12-18 13:42 */
/* ai file: periodismo.ai */

import { makeAi2React } from 'ai2react'

import img0 from './img/periodismo-large.svg'
import img1 from './img/periodismo-mobile.svg'

const styles = `
  #g-periodismo-box ,
  #g-periodismo-box .g-artboard {
    margin:0 auto;
  }
  #g-periodismo-box p {
    margin:0;
  }
  #g-periodismo-box .g-aiAbs {
    position:absolute;
  }
  #g-periodismo-box .g-aiImg {
    position:absolute;
    top:0;
    display:block;
    width:100% !important;
  }
  #g-periodismo-box .g-aiSymbol {
    position: absolute;
    box-sizing: border-box;
  }
  #g-periodismo-box .g-aiPointText p { white-space: nowrap; }
  #g-periodismo-large {
    position:relative;
    overflow:hidden;
  }
  #g-periodismo-large p {
    font-family:Inter, sans-serif;
    font-weight:800;
    line-height:12px;
    height:auto;
    filter:alpha(opacity=100);
    -ms-filter:progid:DXImageTransform.Microsoft.Alpha(Opacity=100);
    opacity:1;
    letter-spacing:-0.029em;
    font-size:10px;
    text-align:left;
    color:rgb(0,0,0);
    text-transform:none;
    padding-bottom:0;
    padding-top:0;
    mix-blend-mode:normal;
    font-style:normal;
    position:static;
  }
  #g-periodismo-large .g-pstyle0 {
    font-weight:normal;
    line-height:11px;
    height:11px;
    letter-spacing:-0.019em;
    font-size:9px;
  }
  #g-periodismo-large .g-pstyle1 {
    line-height:11px;
    height:11px;
    letter-spacing:0em;
    font-size:9px;
  }
  #g-periodismo-large .g-pstyle2 {
    line-height:11px;
    height:11px;
    letter-spacing:-0.02em;
    font-size:9px;
  }
  #g-periodismo-large .g-pstyle3 {
    line-height:11px;
    height:11px;
    letter-spacing:-0.019em;
    font-size:9px;
  }
  #g-periodismo-large .g-pstyle4 {
    line-height:14px;
    height:14px;
    letter-spacing:-0.019em;
    font-size:12px;
  }
  #g-periodismo-large .g-pstyle5 {
    font-weight:normal;
    line-height:13px;
    height:13px;
  }
  #g-periodismo-large .g-pstyle6 {
    font-weight:normal;
    height:12px;
  }
  #g-periodismo-large .g-pstyle7 {
    height:12px;
  }
  #g-periodismo-large .g-pstyle8 {
    font-weight:normal;
    height:12px;
    letter-spacing:0em;
  }
  #g-periodismo-large .g-pstyle9 {
    font-weight:normal;
    height:12px;
    letter-spacing:-0.03em;
  }
  #g-periodismo-large .g-pstyle10 {
    height:12px;
    letter-spacing:-0.03em;
  }
  #g-periodismo-large .g-pstyle11 {
    height:12px;
    letter-spacing:0em;
  }
  #g-periodismo-large .g-pstyle12 {
    font-weight:normal;
    line-height:13px;
  }
  #g-periodismo-large .g-cstyle0 {
    letter-spacing:0em;
  }
  #g-periodismo-large .g-cstyle1 {
    letter-spacing:-0.019em;
  }
  #g-periodismo-large .g-cstyle2 {
    letter-spacing:-0.02em;
  }
  #g-periodismo-large .g-cstyle3 {
    letter-spacing:-0.021em;
  }
  #g-periodismo-large .g-cstyle4 {
    letter-spacing:-0.03em;
  }
  #g-periodismo-large .g-cstyle5 {
    letter-spacing:-0.086em;
  }
  #g-periodismo-large .g-cstyle6 {
    letter-spacing:-0.043em;
  }
  #g-periodismo-large .g-cstyle7 {
    letter-spacing:-0.039em;
  }
  #g-periodismo-large .g-cstyle8 {
    letter-spacing:-0.04em;
  }
  #g-periodismo-large .g-cstyle9 {
    letter-spacing:-0.036em;
  }
  #g-periodismo-large .g-cstyle10 {
    letter-spacing:-0.053em;
  }
  #g-periodismo-large .g-cstyle11 {
    letter-spacing:-0.035em;
  }
  #g-periodismo-large .g-cstyle12 {
    letter-spacing:-0.034em;
  }
  #g-periodismo-large .g-cstyle13 {
    letter-spacing:-0.037em;
  }
  #g-periodismo-large .g-cstyle14 {
    letter-spacing:-0.029em;
  }
  #g-periodismo-large .g-cstyle15 {
    letter-spacing:-0.05em;
  }
  #g-periodismo-large .g-cstyle16 {
    letter-spacing:-0.051em;
  }
  #g-periodismo-large .g-cstyle17 {
    letter-spacing:-0.042em;
  }
  #g-periodismo-large .g-cstyle18 {
    letter-spacing:-0.047em;
  }
  #g-periodismo-large .g-cstyle19 {
    letter-spacing:-0.084em;
  }
  #g-periodismo-large .g-cstyle20 {
    letter-spacing:-0.032em;
  }
  #g-periodismo-large .g-cstyle21 {
    letter-spacing:-0.125em;
  }
  #g-periodismo-large .g-cstyle22 {
    letter-spacing:-0.117em;
  }
  #g-periodismo-large .g-cstyle23 {
    letter-spacing:-0.033em;
  }
  #g-periodismo-large .g-cstyle24 {
    letter-spacing:-0.041em;
  }
  #g-periodismo-mobile {
    position:relative;
    overflow:hidden;
  }
  #g-periodismo-mobile p {
    font-family:Inter, sans-serif;
    font-weight:normal;
    line-height:13px;
    height:auto;
    filter:alpha(opacity=100);
    -ms-filter:progid:DXImageTransform.Microsoft.Alpha(Opacity=100);
    opacity:1;
    letter-spacing:-0.029em;
    font-size:10px;
    text-align:left;
    color:rgb(0,0,0);
    text-transform:none;
    padding-bottom:0;
    padding-top:0;
    mix-blend-mode:normal;
    font-style:normal;
    position:static;
  }
  #g-periodismo-mobile .g-pstyle0 {
    font-weight:800;
    line-height:10px;
    height:10px;
    letter-spacing:-0.019em;
    font-size:8px;
  }
  #g-periodismo-mobile .g-pstyle1 {
    font-weight:800;
    line-height:14px;
    height:14px;
    letter-spacing:-0.019em;
    font-size:12px;
  }
  #g-periodismo-mobile .g-pstyle2 {
    font-weight:800;
    line-height:11px;
    height:11px;
    letter-spacing:-0.019em;
    font-size:9px;
  }
  #g-periodismo-mobile .g-pstyle3 {
    height:13px;
  }
  #g-periodismo-mobile .g-pstyle4 {
    line-height:12px;
    height:12px;
  }
  #g-periodismo-mobile .g-pstyle5 {
    font-weight:800;
    line-height:12px;
    height:12px;
  }
  #g-periodismo-mobile .g-pstyle6 {
    line-height:12px;
    height:12px;
    letter-spacing:-0.03em;
  }
  #g-periodismo-mobile .g-pstyle7 {
    font-weight:800;
    line-height:12px;
    height:12px;
    letter-spacing:-0.03em;
  }
  #g-periodismo-mobile .g-pstyle8 {
    line-height:11px;
    height:11px;
    letter-spacing:-0.019em;
    font-size:9px;
  }
  #g-periodismo-mobile .g-pstyle9 {
    font-weight:800;
    line-height:11px;
    height:11px;
    letter-spacing:0em;
    font-size:9px;
  }
  #g-periodismo-mobile .g-pstyle10 {
    font-weight:800;
    line-height:11px;
    height:11px;
    letter-spacing:-0.02em;
    font-size:9px;
  }
  #g-periodismo-mobile .g-pstyle11 {
    line-height:12px;
    height:12px;
    letter-spacing:0em;
  }
  #g-periodismo-mobile .g-pstyle12 {
    font-weight:800;
    line-height:12px;
    height:12px;
    letter-spacing:0em;
  }
  #g-periodismo-mobile .g-cstyle0 {
    letter-spacing:-0.02em;
  }
  #g-periodismo-mobile .g-cstyle1 {
    letter-spacing:0em;
  }
  #g-periodismo-mobile .g-cstyle2 {
    letter-spacing:-0.021em;
  }
  #g-periodismo-mobile .g-cstyle3 {
    letter-spacing:-0.03em;
  }
  #g-periodismo-mobile .g-cstyle4 {
    letter-spacing:-0.086em;
  }
  #g-periodismo-mobile .g-cstyle5 {
    letter-spacing:-0.043em;
  }
  #g-periodismo-mobile .g-cstyle6 {
    letter-spacing:-0.039em;
  }
  #g-periodismo-mobile .g-cstyle7 {
    letter-spacing:-0.04em;
  }
  #g-periodismo-mobile .g-cstyle8 {
    letter-spacing:-0.053em;
  }
  #g-periodismo-mobile .g-cstyle9 {
    letter-spacing:-0.035em;
  }
  #g-periodismo-mobile .g-cstyle10 {
    letter-spacing:-0.034em;
  }
  #g-periodismo-mobile .g-cstyle11 {
    letter-spacing:-0.036em;
  }
  #g-periodismo-mobile .g-cstyle12 {
    letter-spacing:-0.029em;
  }
  #g-periodismo-mobile .g-cstyle13 {
    letter-spacing:-0.05em;
  }
  #g-periodismo-mobile .g-cstyle14 {
    letter-spacing:-0.051em;
  }
  #g-periodismo-mobile .g-cstyle15 {
    letter-spacing:-0.042em;
  }
  #g-periodismo-mobile .g-cstyle16 {
    letter-spacing:-0.047em;
  }
  #g-periodismo-mobile .g-cstyle17 {
    letter-spacing:-0.037em;
  }
  #g-periodismo-mobile .g-cstyle18 {
    letter-spacing:-0.032em;
  }
  #g-periodismo-mobile .g-cstyle19 {
    letter-spacing:-0.125em;
  }
  #g-periodismo-mobile .g-cstyle20 {
    letter-spacing:-0.117em;
  }
  #g-periodismo-mobile .g-cstyle21 {
    letter-spacing:-0.033em;
  }
  #g-periodismo-mobile .g-cstyle22 {
    letter-spacing:-0.041em;
  }
  #g-periodismo-mobile .g-cstyle23 {
    letter-spacing:-0.019em;
  }
  #g-periodismo-mobile .g-cstyle24 {
    letter-spacing:-0.084em;
  }

`

const html = props => `
<div id="g-periodismo-box" class="ai2html">


  <!-- Artboard: large -->
  <div id="g-periodismo-large" class="g-artboard" style="width:940px; height:425.349999999999px;" data-aspect-ratio="2.21" data-min-width="940">
<div style=""></div>
    <img id="g-periodismo-large-img" class="g-aiImg" alt="" src="${img0}"/>
    <div id="g-ai0-1" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:4.8017%;margin-top:-6.4px;left:53.7051%;width:40px;">
      <p class="g-pstyle0">PD<span class="g-cstyle0">T</span></p>
    </div>
    <div id="g-ai0-2" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:4.8017%;margin-top:-6.4px;left:55.6875%;width:24px;">
      <p class="g-pstyle1"> </p>
    </div>
    <div id="g-ai0-3" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:4.8017%;margin-top:-6.4px;left:58.5788%;width:40px;">
      <p class="g-pstyle0">PD<span class="g-cstyle0">T</span></p>
    </div>
    <div id="g-ai0-4" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:4.8017%;margin-top:-6.4px;left:60.5614%;width:24px;">
      <p class="g-pstyle1"> </p>
    </div>
    <div id="g-ai0-5" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:4.8017%;margin-top:-6.4px;left:63.4609%;width:40px;">
      <p class="g-pstyle0">PD<span class="g-cstyle0">T</span></p>
    </div>
    <div id="g-ai0-6" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:4.8017%;margin-top:-6.4px;left:65.4435%;width:24px;">
      <p class="g-pstyle1"> </p>
    </div>
    <div id="g-ai0-7" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:4.8017%;margin-top:-6.4px;left:68.3345%;width:40px;">
      <p class="g-pstyle0">PD<span class="g-cstyle0">T</span></p>
    </div>
    <div id="g-ai0-8" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:4.8017%;margin-top:-6.4px;left:70.3171%;width:24px;">
      <p class="g-pstyle1"> </p>
    </div>
    <div id="g-ai0-9" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:4.8017%;margin-top:-6.4px;left:78.8636%;width:60px;">
      <p class="g-pstyle2">Ra<span class="g-cstyle1">n</span>k<span class="g-cstyle1">in</span>g<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-10" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:4.8017%;margin-top:-6.4px;left:94.6103%;width:58px;">
      <p class="g-pstyle3"><span class="g-cstyle2">A</span>rancel<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-11" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:7.0468%;margin-top:-8px;left:2.2048%;width:90px;">
      <p class="g-pstyle4">Univ<span class="g-cstyle2">e</span>r<span class="g-cstyle2">s</span>ida<span class="g-cstyle0">d</span></p>
    </div>
    <div id="g-ai0-12" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:7.1527%;margin-top:-6.4px;left:22.189%;width:44px;">
      <p class="g-pstyle3">Sed<span class="g-cstyle0">e</span></p>
    </div>
    <div id="g-ai0-13" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:7.1527%;margin-top:-6.4px;left:29.9775%;width:63px;">
      <p class="g-pstyle3">M<span class="g-cstyle3">í</span>n <span class="g-cstyle2">P</span>o<span class="g-cstyle2">n</span><span class="g-cstyle0">d</span></p>
    </div>
    <div id="g-ai0-14" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:7.1527%;margin-top:-6.4px;left:37.5597%;width:70px;">
      <p class="g-pstyle3">Prom P<span class="g-cstyle2">o</span>n<span class="g-cstyle0">d</span></p>
    </div>
    <div id="g-ai0-15" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:7.1527%;margin-top:-6.4px;left:45.9013%;width:65px;">
      <p class="g-pstyle3"><span class="g-cstyle2">M</span>áx Po<span class="g-cstyle2">n</span><span class="g-cstyle0">d</span></p>
    </div>
    <div id="g-ai0-16" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:7.1527%;margin-top:-6.4px;left:73.3031%;width:44px;">
      <p class="g-pstyle3"> NE<span class="g-cstyle0">M</span></p>
    </div>
    <div id="g-ai0-17" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:7.1527%;margin-top:-6.4px;left:85.6098%;width:64px;">
      <p class="g-pstyle2">Va<span class="g-cstyle1">c</span>a<span class="g-cstyle1">n</span>te<span class="g-cstyle0">s</span></p>
    </div>
    <div id="g-ai0-18" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:7.1527%;margin-top:-6.4px;left:53.6576%;width:41px;">
      <p class="g-pstyle3">len<span class="g-cstyle0">g</span></p>
    </div>
    <div id="g-ai0-19" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:7.1527%;margin-top:-6.4px;left:58.6262%;width:39px;">
      <p class="g-pstyle2"><span class="g-cstyle1">m</span>a<span class="g-cstyle0">t</span></p>
    </div>
    <div id="g-ai0-20" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:7.1527%;margin-top:-6.4px;left:63.4688%;width:41px;">
      <p class="g-pstyle3">cie<span class="g-cstyle0">n</span></p>
    </div>
    <div id="g-ai0-21" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:7.1527%;margin-top:-6.4px;left:68.453%;width:39px;">
      <p class="g-pstyle3">his<span class="g-cstyle0">t</span></p>
    </div>
    <div id="g-ai0-22" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:7.1527%;margin-top:-6.4px;left:79.4876%;width:47px;">
      <p class="g-pstyle3">not<span class="g-cstyle2">a</span><span class="g-cstyle0">s</span></p>
    </div>
    <div id="g-ai0-23" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:7.1527%;margin-top:-6.4px;left:93.1727%;width:70px;">
      <p class="g-pstyle3">referen<span class="g-cstyle2">c</span>ia<span class="g-cstyle0">l</span></p>
    </div>
    <div id="g-ai0-24" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:13.0948%;margin-top:-7.7px;left:2.1574%;width:87px;">
      <p class="g-pstyle5">PUC de<span class="g-cstyle4"> </span>Ch<span class="g-cstyle4">i</span>le<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-25" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:13.2123%;margin-top:-7.2px;left:21.3832%;width:65px;">
      <p class="g-pstyle6"><span class="g-cstyle4">S</span>anti<span class="g-cstyle4">a</span>g<span class="g-cstyle4">o</span><span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-26" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:13.2123%;margin-top:-7.2px;left:30.5069%;width:59px;">
      <p class="g-pstyle7">66<span class="g-cstyle5">7</span><span class="g-cstyle4">,8</span>0<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-27" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:13.2123%;margin-top:-7.2px;left:38.5797%;width:57px;">
      <p class="g-pstyle7">701<span class="g-cstyle6">,</span>76<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-28" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:13.2123%;margin-top:-7.2px;left:46.5254%;width:60px;">
      <p class="g-pstyle7">78<span class="g-cstyle7">0</span><span class="g-cstyle8">,</span>9<span class="g-cstyle4">0</span><span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-29" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:13.2123%;margin-top:-7.2px;left:53.6814%;width:45px;">
      <p class="g-pstyle6">2<span class="g-cstyle4">0</span>%<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-30" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:13.2123%;margin-top:-7.2px;left:58.5634%;width:45px;">
      <p class="g-pstyle6">2<span class="g-cstyle4">0</span>%<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-31" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:13.2123%;margin-top:-7.2px;left:64.4639%;width:25px;">
      <p class="g-pstyle8"> </p>
    </div>
    <div id="g-ai0-32" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:13.2123%;margin-top:-7.2px;left:68.3581%;width:43px;">
      <p class="g-pstyle6">1<span class="g-cstyle4">0</span>%<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-33" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:13.2123%;margin-top:-7.2px;left:73.5481%;width:45px;">
      <p class="g-pstyle6">25%<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-34" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:13.2123%;margin-top:-7.2px;left:79.7719%;width:45px;">
      <p class="g-pstyle7"><span class="g-cstyle4">2</span>5%<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-35" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:13.2123%;margin-top:-7.2px;left:86.9279%;width:42px;">
      <p class="g-pstyle7">1<span class="g-cstyle4">2</span>5<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-36" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:13.2123%;margin-top:-7.2px;left:92.6919%;width:83px;">
      <p class="g-pstyle7"><span class="g-cstyle4">$</span>5<span class="g-cstyle4">.</span>588<span class="g-cstyle9">.</span><span class="g-cstyle4">0</span>00<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-37" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:16.3862%;margin-top:-7.7px;left:2.1574%;width:75px;">
      <p class="g-pstyle5"><span class="g-cstyle10">U</span>. de C<span class="g-cstyle4">h</span>i<span class="g-cstyle4">le</span><span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-38" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:16.5038%;margin-top:-7.2px;left:21.3832%;width:65px;">
      <p class="g-pstyle6"><span class="g-cstyle4">S</span>anti<span class="g-cstyle4">a</span>g<span class="g-cstyle4">o</span><span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-39" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:16.5038%;margin-top:-7.2px;left:30.5226%;width:59px;">
      <p class="g-pstyle7">63<span class="g-cstyle5">7</span><span class="g-cstyle11">,</span><span class="g-cstyle4">0</span>0<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-40" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:16.5038%;margin-top:-7.2px;left:38.54%;width:59px;">
      <p class="g-pstyle7">67<span class="g-cstyle12">3</span>,3<span class="g-cstyle4">0</span><span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-41" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:16.5038%;margin-top:-7.2px;left:46.5807%;width:57px;">
      <p class="g-pstyle7">791,<span class="g-cstyle4">5</span>0<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-42" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:16.5038%;margin-top:-7.2px;left:53.6892%;width:45px;">
      <p class="g-pstyle6">3<span class="g-cstyle4">0</span>%<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-43" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:16.5038%;margin-top:-7.2px;left:58.6424%;width:43px;">
      <p class="g-pstyle6">15%<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-44" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:16.5038%;margin-top:-7.2px;left:64.4639%;width:25px;">
      <p class="g-pstyle8"> </p>
    </div>
    <div id="g-ai0-45" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:16.5038%;margin-top:-7.2px;left:68.3976%;width:43px;">
      <p class="g-pstyle6">15%<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-46" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:16.5038%;margin-top:-7.2px;left:73.556%;width:43px;">
      <p class="g-pstyle6">1<span class="g-cstyle4">0</span>%<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-47" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:16.5038%;margin-top:-7.2px;left:79.7483%;width:46px;">
      <p class="g-pstyle7">30%<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-48" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:16.5038%;margin-top:-7.2px;left:86.9279%;width:41px;">
      <p class="g-pstyle7">11<span class="g-cstyle4">0</span><span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-49" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:16.5038%;margin-top:-7.2px;left:92.8104%;width:82px;">
      <p class="g-pstyle7"><span class="g-cstyle4">$</span>3<span class="g-cstyle9">.</span>755<span class="g-cstyle4">.</span>80<span class="g-cstyle4">0</span><span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-50" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:19.9127%;margin-top:-7.7px;left:2.1574%;width:134px;">
      <p class="g-pstyle5"><span class="g-cstyle10">U</span>. de San<span class="g-cstyle4">ti</span>ago de Chile<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-51" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:20.0303%;margin-top:-7.2px;left:21.3832%;width:65px;">
      <p class="g-pstyle6"><span class="g-cstyle4">S</span>anti<span class="g-cstyle4">a</span>g<span class="g-cstyle4">o</span><span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-52" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:20.0303%;margin-top:-7.2px;left:30.4438%;width:61px;">
      <p class="g-pstyle7">6<span class="g-cstyle4">0</span><span class="g-cstyle7">0</span><span class="g-cstyle8">,</span>90<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-53" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:20.0303%;margin-top:-7.2px;left:39.6144%;width:36px;">
      <p class="g-pstyle7">s/<span class="g-cstyle4">i</span><span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-54" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:20.0303%;margin-top:-7.2px;left:46.5176%;width:60px;">
      <p class="g-pstyle7">696<span class="g-cstyle4">,</span>50<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-55" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:20.0303%;margin-top:-7.2px;left:53.6892%;width:45px;">
      <p class="g-pstyle6">3<span class="g-cstyle4">0</span>%<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-56" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:20.0303%;margin-top:-7.2px;left:58.6108%;width:43px;">
      <p class="g-pstyle6">1<span class="g-cstyle4">0</span>%<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-57" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:20.0303%;margin-top:-7.2px;left:64.4639%;width:25px;">
      <p class="g-pstyle8"> </p>
    </div>
    <div id="g-ai0-58" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:20.0303%;margin-top:-7.2px;left:68.3581%;width:43px;">
      <p class="g-pstyle6">1<span class="g-cstyle4">0</span>%<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-59" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:20.0303%;margin-top:-7.2px;left:73.556%;width:43px;">
      <p class="g-pstyle6">1<span class="g-cstyle4">0</span>%<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-60" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:20.0303%;margin-top:-7.2px;left:79.7167%;width:46px;">
      <p class="g-pstyle7">4<span class="g-cstyle4">0</span>%<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-61" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:20.0303%;margin-top:-7.2px;left:87.2043%;width:37px;">
      <p class="g-pstyle7">65<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-62" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:20.0303%;margin-top:-7.2px;left:92.7077%;width:83px;">
      <p class="g-pstyle7"><span class="g-cstyle4">$</span>3<span class="g-cstyle4">.</span>545<span class="g-cstyle13">.</span>0<span class="g-cstyle4">0</span>0<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-63" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:23.2041%;margin-top:-7.7px;left:2.1574%;width:107px;">
      <p class="g-pstyle5"><span class="g-cstyle10">U</span>. Ad<span class="g-cstyle4">o</span>lfo<span class="g-cstyle4"> </span>Ibáñez*<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-64" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:23.3217%;margin-top:-7.2px;left:21.3832%;width:65px;">
      <p class="g-pstyle6"><span class="g-cstyle4">S</span>anti<span class="g-cstyle4">a</span>g<span class="g-cstyle4">o</span><span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-65" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:23.3217%;margin-top:-7.2px;left:30.4753%;width:60px;">
      <p class="g-pstyle7">592<span class="g-cstyle9">,</span>00<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-66" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:23.3217%;margin-top:-7.2px;left:38.4769%;width:60px;">
      <p class="g-pstyle7">64<span class="g-cstyle7">0</span><span class="g-cstyle4">,</span>28<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-67" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:23.3217%;margin-top:-7.2px;left:46.5334%;width:59px;">
      <p class="g-pstyle7">726<span class="g-cstyle11">,</span><span class="g-cstyle4">0</span>0<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-68" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:23.3217%;margin-top:-7.2px;left:53.7209%;width:45px;">
      <p class="g-pstyle6">25%<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-69" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:23.3217%;margin-top:-7.2px;left:58.6424%;width:43px;">
      <p class="g-pstyle6">15%<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-70" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:23.3217%;margin-top:-7.2px;left:63.4846%;width:43px;">
      <p class="g-pstyle6">1<span class="g-cstyle4">0</span>%<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-71" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:23.3217%;margin-top:-7.2px;left:68.3581%;width:43px;">
      <p class="g-pstyle6">1<span class="g-cstyle4">0</span>%<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-72" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:23.3217%;margin-top:-7.2px;left:73.556%;width:43px;">
      <p class="g-pstyle6">1<span class="g-cstyle4">0</span>%<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-73" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:23.3217%;margin-top:-7.2px;left:79.7167%;width:46px;">
      <p class="g-pstyle7">4<span class="g-cstyle4">0</span>%<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-74" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:23.3217%;margin-top:-7.2px;left:87.2122%;width:37px;">
      <p class="g-pstyle7"><span class="g-cstyle4">2</span>5<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-75" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:23.3217%;margin-top:-7.2px;left:94.8798%;width:57px;">
      <p class="g-pstyle7">19<span class="g-cstyle4">0</span> <span class="g-cstyle4">U</span>F<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-76" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:26.7306%;margin-top:-7.7px;left:2.1574%;width:108px;">
      <p class="g-pstyle5"><span class="g-cstyle10">U</span>. de C<span class="g-cstyle4">o</span>ncepción<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-77" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:26.8482%;margin-top:-7.2px;left:20.5064%;width:79px;">
      <p class="g-pstyle9">Co<span class="g-cstyle14">n</span>ce<span class="g-cstyle14">p</span>ció<span class="g-cstyle14">n</span><span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-78" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:26.8482%;margin-top:-7.2px;left:30.4832%;width:60px;">
      <p class="g-pstyle7">56<span class="g-cstyle7">0</span>,4<span class="g-cstyle4">5</span><span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-79" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:26.8482%;margin-top:-7.2px;left:38.5085%;width:59px;">
      <p class="g-pstyle7">60<span class="g-cstyle5">7</span>,4<span class="g-cstyle4">0</span><span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-80" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:26.8482%;margin-top:-7.2px;left:46.549%;width:60px;">
      <p class="g-pstyle7">68<span class="g-cstyle12">8</span>,35<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-81" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:26.8482%;margin-top:-7.2px;left:53.6892%;width:45px;">
      <p class="g-pstyle6">3<span class="g-cstyle4">0</span>%<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-82" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:26.8482%;margin-top:-7.2px;left:58.6424%;width:43px;">
      <p class="g-pstyle6">15%<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-83" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:26.8482%;margin-top:-7.2px;left:64.4639%;width:25px;">
      <p class="g-pstyle8"> </p>
    </div>
    <div id="g-ai0-84" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:26.8482%;margin-top:-7.2px;left:68.3976%;width:43px;">
      <p class="g-pstyle6">15%<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-85" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:26.8482%;margin-top:-7.2px;left:73.5956%;width:43px;">
      <p class="g-pstyle6">15%<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-86" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:26.8482%;margin-top:-7.2px;left:79.7719%;width:45px;">
      <p class="g-pstyle7"><span class="g-cstyle4">2</span>5%<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-87" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:26.8482%;margin-top:-7.2px;left:87.1965%;width:37px;">
      <p class="g-pstyle10"><span class="g-cstyle14">5</span>0<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-88" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:26.8482%;margin-top:-7.2px;left:92.6996%;width:82px;">
      <p class="g-pstyle7"><span class="g-cstyle4">$</span>4<span class="g-cstyle4">.</span>2<span class="g-cstyle4">4</span>4.<span class="g-cstyle4">5</span>65<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-89" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:30.022%;margin-top:-7.7px;left:2.1574%;width:117px;">
      <p class="g-pstyle5">PUC de<span class="g-cstyle4"> </span><span class="g-cstyle15">V</span>alp<span class="g-cstyle4">a</span>raíso<span class="g-cstyle4">*</span><span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-90" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:30.1396%;margin-top:-7.2px;left:21.0357%;width:72px;">
      <p class="g-pstyle6"><span class="g-cstyle16">V</span>alpar<span class="g-cstyle4">a</span>í<span class="g-cstyle4">s</span>o<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-91" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:30.1396%;margin-top:-7.2px;left:30.5542%;width:58px;">
      <p class="g-pstyle10"><span class="g-cstyle14">5</span>4<span class="g-cstyle5">7</span><span class="g-cstyle17">,</span><span class="g-cstyle14">7</span>0<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-92" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:30.1396%;margin-top:-7.2px;left:38.5005%;width:60px;">
      <p class="g-pstyle7">60<span class="g-cstyle12">3</span><span class="g-cstyle4">,</span>30<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-93" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:30.1396%;margin-top:-7.2px;left:46.5334%;width:59px;">
      <p class="g-pstyle7">72<span class="g-cstyle18">9</span>,4<span class="g-cstyle4">0</span><span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-94" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:30.1396%;margin-top:-7.2px;left:53.6892%;width:45px;">
      <p class="g-pstyle6">3<span class="g-cstyle4">0</span>%<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-95" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:30.1396%;margin-top:-7.2px;left:58.5634%;width:45px;">
      <p class="g-pstyle6">2<span class="g-cstyle4">0</span>%<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-96" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:30.1396%;margin-top:-7.2px;left:63.4846%;width:43px;">
      <p class="g-pstyle6">1<span class="g-cstyle4">0</span>%<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-97" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:30.1396%;margin-top:-7.2px;left:68.3581%;width:43px;">
      <p class="g-pstyle6">1<span class="g-cstyle4">0</span>%<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-98" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:30.1396%;margin-top:-7.2px;left:73.5167%;width:45px;">
      <p class="g-pstyle6">2<span class="g-cstyle4">0</span>%<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-99" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:30.1396%;margin-top:-7.2px;left:79.7404%;width:46px;">
      <p class="g-pstyle7"><span class="g-cstyle4">2</span>0%<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-100" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:30.1396%;margin-top:-7.2px;left:87.1726%;width:38px;">
      <p class="g-pstyle7">80<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-101" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:30.1396%;margin-top:-7.2px;left:92.6839%;width:83px;">
      <p class="g-pstyle7"><span class="g-cstyle4">$</span>3<span class="g-cstyle9">.</span>93<span class="g-cstyle13">0</span><span class="g-cstyle9">.</span><span class="g-cstyle4">0</span>00<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-102" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:33.3134%;margin-top:-7.7px;left:2.1574%;width:103px;">
      <p class="g-pstyle5"><span class="g-cstyle10">U</span>. de los <span class="g-cstyle4">A</span>ndes*<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-103" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:33.431%;margin-top:-7.2px;left:21.3832%;width:65px;">
      <p class="g-pstyle6"><span class="g-cstyle4">S</span>anti<span class="g-cstyle4">a</span>g<span class="g-cstyle4">o</span><span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-104" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:33.431%;margin-top:-7.2px;left:30.4753%;width:60px;">
      <p class="g-pstyle7">5<span class="g-cstyle4">4</span><span class="g-cstyle12">3</span>,80<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-105" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:33.431%;margin-top:-7.2px;left:38.469%;width:60px;">
      <p class="g-pstyle7">60<span class="g-cstyle4">2</span><span class="g-cstyle9">,</span>00<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-106" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:33.431%;margin-top:-7.2px;left:46.5807%;width:59px;">
      <p class="g-pstyle7">736<span class="g-cstyle6">,</span>70<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-107" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:33.431%;margin-top:-7.2px;left:53.6656%;width:45px;">
      <p class="g-pstyle6">4<span class="g-cstyle4">0</span>%<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-108" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:33.431%;margin-top:-7.2px;left:58.5634%;width:45px;">
      <p class="g-pstyle6">2<span class="g-cstyle4">0</span>%<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-109" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:33.431%;margin-top:-7.2px;left:63.5161%;width:43px;">
      <p class="g-pstyle6">15%<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-110" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:33.431%;margin-top:-7.2px;left:68.3976%;width:43px;">
      <p class="g-pstyle6">15%<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-111" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:33.431%;margin-top:-7.2px;left:73.556%;width:43px;">
      <p class="g-pstyle6">1<span class="g-cstyle4">0</span>%<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-112" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:33.431%;margin-top:-7.2px;left:79.7955%;width:44px;">
      <p class="g-pstyle7">15%<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-113" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:33.431%;margin-top:-7.2px;left:87.1965%;width:37px;">
      <p class="g-pstyle7">47<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-114" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:33.431%;margin-top:-7.2px;left:94.951%;width:56px;">
      <p class="g-pstyle7">178<span class="g-cstyle4"> </span>U<span class="g-cstyle4">F</span><span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-115" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:36.84%;margin-top:-7.7px;left:2.1574%;width:110px;">
      <p class="g-pstyle5"><span class="g-cstyle10">U</span>. Di<span class="g-cstyle4">eg</span>o<span class="g-cstyle4"> </span>P<span class="g-cstyle4">o</span>rtale<span class="g-cstyle4">s</span>*<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-116" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:36.9575%;margin-top:-7.2px;left:21.3832%;width:65px;">
      <p class="g-pstyle6"><span class="g-cstyle4">S</span>anti<span class="g-cstyle4">a</span>g<span class="g-cstyle4">o</span><span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-117" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:36.9575%;margin-top:-7.2px;left:30.4911%;width:60px;">
      <p class="g-pstyle7">536<span class="g-cstyle11">,</span>6<span class="g-cstyle4">0</span><span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-118" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:36.9575%;margin-top:-7.2px;left:38.5243%;width:60px;">
      <p class="g-pstyle7">585<span class="g-cstyle4">,</span>88<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-119" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:36.9575%;margin-top:-7.2px;left:46.5096%;width:60px;">
      <p class="g-pstyle7">66<span class="g-cstyle4">2</span>,8<span class="g-cstyle4">0</span><span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-120" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:36.9575%;margin-top:-7.2px;left:53.6892%;width:45px;">
      <p class="g-pstyle6">5<span class="g-cstyle4">0</span>%<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-121" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:36.9575%;margin-top:-7.2px;left:58.5634%;width:45px;">
      <p class="g-pstyle6">2<span class="g-cstyle4">0</span>%<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-122" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:36.9575%;margin-top:-7.2px;left:63.4846%;width:43px;">
      <p class="g-pstyle6">1<span class="g-cstyle4">0</span>%<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-123" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:36.9575%;margin-top:-7.2px;left:68.3581%;width:43px;">
      <p class="g-pstyle6">1<span class="g-cstyle4">0</span>%<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-124" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:36.9575%;margin-top:-7.2px;left:73.556%;width:43px;">
      <p class="g-pstyle6">1<span class="g-cstyle4">0</span>%<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-125" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:36.9575%;margin-top:-7.2px;left:79.7641%;width:44px;">
      <p class="g-pstyle7">1<span class="g-cstyle4">0</span>%<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-126" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:36.9575%;margin-top:-7.2px;left:86.9199%;width:42px;">
      <p class="g-pstyle7">136<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-127" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:36.9575%;margin-top:-7.2px;left:92.6917%;width:83px;">
      <p class="g-pstyle7"><span class="g-cstyle4">$</span>5<span class="g-cstyle4">.</span>45<span class="g-cstyle4">2</span><span class="g-cstyle9">.</span><span class="g-cstyle4">0</span>00<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-128" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:40.1314%;margin-top:-7.7px;left:2.1574%;width:176px;">
      <p class="g-pstyle5">UC <span class="g-cstyle4">d</span>e<span class="g-cstyle4"> </span>la<span class="g-cstyle4"> </span>Sant<span class="g-cstyle4">í</span>sima C<span class="g-cstyle4">o</span>n<span class="g-cstyle4">c</span>epció<span class="g-cstyle4">n</span>*<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-129" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:40.2489%;margin-top:-7.2px;left:20.5064%;width:79px;">
      <p class="g-pstyle9">Co<span class="g-cstyle14">n</span>ce<span class="g-cstyle14">p</span>ció<span class="g-cstyle14">n</span><span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-130" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:40.2489%;margin-top:-7.2px;left:58.6108%;width:43px;">
      <p class="g-pstyle6">1<span class="g-cstyle4">0</span>%<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-131" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:40.2489%;margin-top:-7.2px;left:68.3581%;width:43px;">
      <p class="g-pstyle6">1<span class="g-cstyle4">0</span>%<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-132" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:40.2489%;margin-top:-7.2px;left:79.7167%;width:46px;">
      <p class="g-pstyle7">4<span class="g-cstyle4">0</span>%<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-133" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:40.2489%;margin-top:-7.2px;left:30.5464%;width:58px;">
      <p class="g-pstyle7">535<span class="g-cstyle4">,</span>10<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-134" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:40.2489%;margin-top:-7.2px;left:38.5005%;width:60px;">
      <p class="g-pstyle7">58<span class="g-cstyle12">8</span>,8<span class="g-cstyle4">9</span><span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-135" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:40.2489%;margin-top:-7.2px;left:46.5729%;width:58px;">
      <p class="g-pstyle7">71<span class="g-cstyle9">4</span>,5<span class="g-cstyle4">0</span><span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-136" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:40.2489%;margin-top:-7.2px;left:53.6814%;width:45px;">
      <p class="g-pstyle6">2<span class="g-cstyle4">0</span>%<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-137" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:40.2489%;margin-top:-7.2px;left:63.4846%;width:43px;">
      <p class="g-pstyle6">1<span class="g-cstyle4">0</span>%<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-138" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:40.2489%;margin-top:-7.2px;left:73.5167%;width:45px;">
      <p class="g-pstyle6">2<span class="g-cstyle4">0</span>%<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-139" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:40.2489%;margin-top:-7.2px;left:87.2201%;width:37px;">
      <p class="g-pstyle7">55<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-140" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:40.2489%;margin-top:-7.2px;left:92.6601%;width:83px;">
      <p class="g-pstyle7"><span class="g-cstyle4">$</span>3<span class="g-cstyle4">.</span>50<span class="g-cstyle13">0</span><span class="g-cstyle9">.</span>0<span class="g-cstyle4">0</span>0<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-141" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:43.6579%;margin-top:-7.7px;left:2.1574%;width:117px;">
      <p class="g-pstyle5"><span class="g-cstyle10">U</span>. Alber<span class="g-cstyle4">t</span>o Hurta<span class="g-cstyle4">d</span>o*<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-142" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:43.7754%;margin-top:-7.2px;left:21.3832%;width:65px;">
      <p class="g-pstyle6"><span class="g-cstyle4">S</span>anti<span class="g-cstyle4">a</span>g<span class="g-cstyle4">o</span><span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-143" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:43.7754%;margin-top:-7.2px;left:30.5148%;width:58px;">
      <p class="g-pstyle10"><span class="g-cstyle14">5</span>1<span class="g-cstyle12">3</span><span class="g-cstyle11">,</span>0<span class="g-cstyle14">0</span><span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-144" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:43.7754%;margin-top:-7.2px;left:38.4847%;width:61px;">
      <p class="g-pstyle7">56<span class="g-cstyle7">0</span><span class="g-cstyle9">,</span>0<span class="g-cstyle4">0</span><span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-145" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:43.7754%;margin-top:-7.2px;left:46.5018%;width:60px;">
      <p class="g-pstyle7">66<span class="g-cstyle18">9</span><span class="g-cstyle9">,</span><span class="g-cstyle4">0</span>0<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-146" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:43.7754%;margin-top:-7.2px;left:53.6892%;width:45px;">
      <p class="g-pstyle6">3<span class="g-cstyle4">0</span>%<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-147" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:43.7754%;margin-top:-7.2px;left:58.6424%;width:43px;">
      <p class="g-pstyle6">15%<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-148" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:43.7754%;margin-top:-7.2px;left:63.4846%;width:43px;">
      <p class="g-pstyle6">1<span class="g-cstyle4">0</span>%<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-149" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:43.7754%;margin-top:-7.2px;left:68.3581%;width:43px;">
      <p class="g-pstyle6">1<span class="g-cstyle4">0</span>%<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-150" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:43.7754%;margin-top:-7.2px;left:73.556%;width:43px;">
      <p class="g-pstyle6">1<span class="g-cstyle4">0</span>%<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-151" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:43.7754%;margin-top:-7.2px;left:79.7799%;width:46px;">
      <p class="g-pstyle7">35%<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-152" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:43.7754%;margin-top:-7.2px;left:87.2043%;width:37px;">
      <p class="g-pstyle7">70<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-153" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:43.7754%;margin-top:-7.2px;left:92.7787%;width:82px;">
      <p class="g-pstyle10">$<span class="g-cstyle14">5</span><span class="g-cstyle13">.</span><span class="g-cstyle14">0</span>2<span class="g-cstyle19">7</span><span class="g-cstyle9">.</span>0<span class="g-cstyle14">0</span>0<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-154" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:46.9493%;margin-top:-7.7px;left:2.1574%;width:105px;">
      <p class="g-pstyle5"><span class="g-cstyle10">U</span>. de La <span class="g-cstyle13">F</span><span class="g-cstyle20">r</span>o<span class="g-cstyle4">n</span>tera<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-155" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:47.0668%;margin-top:-7.2px;left:21.4702%;width:61px;">
      <p class="g-pstyle6"><span class="g-cstyle21">T</span>emu<span class="g-cstyle4">co</span><span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-156" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:47.0668%;margin-top:-7.2px;left:30.5069%;width:58px;">
      <p class="g-pstyle7">5<span class="g-cstyle4">1</span><span class="g-cstyle7">0</span><span class="g-cstyle8">,</span>90<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-157" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:47.0668%;margin-top:-7.2px;left:38.5875%;width:57px;">
      <p class="g-pstyle7">56<span class="g-cstyle18">9</span><span class="g-cstyle17">,</span>71<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-158" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:47.0668%;margin-top:-7.2px;left:46.5887%;width:58px;">
      <p class="g-pstyle7">67<span class="g-cstyle12">3</span>,<span class="g-cstyle4">1</span>0<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-159" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:47.0668%;margin-top:-7.2px;left:53.6892%;width:45px;">
      <p class="g-pstyle6">3<span class="g-cstyle4">0</span>%<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-160" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:47.0668%;margin-top:-7.2px;left:58.5634%;width:45px;">
      <p class="g-pstyle6">2<span class="g-cstyle4">0</span>%<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-161" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:47.0668%;margin-top:-7.2px;left:64.4639%;width:25px;">
      <p class="g-pstyle8"> </p>
    </div>
    <div id="g-ai0-162" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:47.0668%;margin-top:-7.2px;left:68.3581%;width:43px;">
      <p class="g-pstyle6">1<span class="g-cstyle4">0</span>%<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-163" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:47.0668%;margin-top:-7.2px;left:73.556%;width:43px;">
      <p class="g-pstyle6">1<span class="g-cstyle4">0</span>%<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-164" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:47.0668%;margin-top:-7.2px;left:79.7483%;width:46px;">
      <p class="g-pstyle7">30%<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-165" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:47.0668%;margin-top:-7.2px;left:87.2122%;width:37px;">
      <p class="g-pstyle7"><span class="g-cstyle4">2</span>5<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-166" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:47.0668%;margin-top:-7.2px;left:92.7865%;width:81px;">
      <p class="g-pstyle7"><span class="g-cstyle4">$</span>3<span class="g-cstyle4">.</span>2<span class="g-cstyle4">1</span>5<span class="g-cstyle9">.</span><span class="g-cstyle4">0</span>00<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-167" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:50.2407%;margin-top:-7.7px;left:2.1574%;width:106px;">
      <p class="g-pstyle5"><span class="g-cstyle10">U</span>. de<span class="g-cstyle4">l</span> De<span class="g-cstyle4">s</span>a<span class="g-cstyle4">r</span><span class="g-cstyle20">r</span><span class="g-cstyle4">o</span>ll<span class="g-cstyle4">o</span>*<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-168" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:50.3582%;margin-top:-7.2px;left:21.3832%;width:65px;">
      <p class="g-pstyle6"><span class="g-cstyle4">S</span>anti<span class="g-cstyle4">a</span>g<span class="g-cstyle4">o</span><span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-169" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:50.3582%;margin-top:-7.2px;left:30.499%;width:58px;">
      <p class="g-pstyle7">5<span class="g-cstyle4">01</span><span class="g-cstyle8">,</span>90<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-170" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:50.3582%;margin-top:-7.2px;left:38.5163%;width:60px;">
      <p class="g-pstyle7">57<span class="g-cstyle12">8</span><span class="g-cstyle9">,</span>00<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-171" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:50.3582%;margin-top:-7.2px;left:46.5648%;width:59px;">
      <p class="g-pstyle7">72<span class="g-cstyle4">5</span><span class="g-cstyle11">,</span>6<span class="g-cstyle4">0</span><span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-172" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:50.3582%;margin-top:-7.2px;left:53.7209%;width:45px;">
      <p class="g-pstyle6">35%<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-173" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:50.3582%;margin-top:-7.2px;left:58.595%;width:45px;">
      <p class="g-pstyle6">35%<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-174" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:50.3582%;margin-top:-7.2px;left:63.4846%;width:43px;">
      <p class="g-pstyle6">1<span class="g-cstyle4">0</span>%<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-175" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:50.3582%;margin-top:-7.2px;left:68.3581%;width:43px;">
      <p class="g-pstyle6">1<span class="g-cstyle4">0</span>%<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-176" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:50.3582%;margin-top:-7.2px;left:73.556%;width:43px;">
      <p class="g-pstyle6">1<span class="g-cstyle4">0</span>%<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-177" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:50.3582%;margin-top:-7.2px;left:79.7641%;width:44px;">
      <p class="g-pstyle7">1<span class="g-cstyle4">0</span>%<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-178" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:50.3582%;margin-top:-7.2px;left:87.2201%;width:37px;">
      <p class="g-pstyle7">55<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-179" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:50.3582%;margin-top:-7.2px;left:94.9352%;width:56px;">
      <p class="g-pstyle7"><span class="g-cstyle4">2</span>2<span class="g-cstyle4">1</span> <span class="g-cstyle4">U</span>F<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-180" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:53.7672%;margin-top:-7.7px;left:2.1574%;width:96px;">
      <p class="g-pstyle5"><span class="g-cstyle10">U</span>. Fi<span class="g-cstyle4">n</span>is <span class="g-cstyle22">T</span>erra<span class="g-cstyle4">e</span>*<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-181" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:53.8847%;margin-top:-7.2px;left:21.3832%;width:65px;">
      <p class="g-pstyle6"><span class="g-cstyle4">S</span>anti<span class="g-cstyle4">a</span>g<span class="g-cstyle4">o</span><span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-182" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:53.8847%;margin-top:-7.2px;left:30.499%;width:58px;">
      <p class="g-pstyle7">5<span class="g-cstyle4">01</span><span class="g-cstyle8">,</span>90<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-183" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:53.8847%;margin-top:-7.2px;left:38.469%;width:60px;">
      <p class="g-pstyle7">54<span class="g-cstyle9">4</span>,<span class="g-cstyle4">4</span>9<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-184" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:53.8847%;margin-top:-7.2px;left:46.5729%;width:58px;">
      <p class="g-pstyle7">61<span class="g-cstyle4">5</span>,50<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-185" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:53.8847%;margin-top:-7.2px;left:53.6656%;width:45px;">
      <p class="g-pstyle6">4<span class="g-cstyle4">0</span>%<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-186" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:53.8847%;margin-top:-7.2px;left:58.6108%;width:43px;">
      <p class="g-pstyle6">1<span class="g-cstyle4">0</span>%<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-187" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:53.8847%;margin-top:-7.2px;left:63.4846%;width:43px;">
      <p class="g-pstyle6">1<span class="g-cstyle4">0</span>%<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-188" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:53.8847%;margin-top:-7.2px;left:68.3581%;width:43px;">
      <p class="g-pstyle6">1<span class="g-cstyle4">0</span>%<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-189" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:53.8847%;margin-top:-7.2px;left:73.556%;width:43px;">
      <p class="g-pstyle6">1<span class="g-cstyle4">0</span>%<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-190" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:53.8847%;margin-top:-7.2px;left:79.7483%;width:46px;">
      <p class="g-pstyle7">30%<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-191" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:53.8847%;margin-top:-7.2px;left:87.1726%;width:38px;">
      <p class="g-pstyle7">90<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-192" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:53.8847%;margin-top:-7.2px;left:92.597%;width:83px;">
      <p class="g-pstyle7"><span class="g-cstyle4">$</span>4<span class="g-cstyle4">.</span>54<span class="g-cstyle13">0</span><span class="g-cstyle9">.</span>0<span class="g-cstyle4">0</span>0<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-193" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:57.0586%;margin-top:-7.7px;left:2.1574%;width:121px;">
      <p class="g-pstyle5"><span class="g-cstyle10">U</span>. C<span class="g-cstyle23">a</span>tólic<span class="g-cstyle4">a</span> del Norte<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-194" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:57.1761%;margin-top:-7.2px;left:20.6406%;width:80px;">
      <p class="g-pstyle6">Ant<span class="g-cstyle20">o</span>fa<span class="g-cstyle4">g</span>a<span class="g-cstyle4">s</span>ta<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-195" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:57.1761%;margin-top:-7.2px;left:30.4596%;width:60px;">
      <p class="g-pstyle10"><span class="g-cstyle14">5</span>0<span class="g-cstyle7">0</span><span class="g-cstyle8">,</span><span class="g-cstyle14">9</span>0<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-196" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:57.1761%;margin-top:-7.2px;left:38.5639%;width:58px;">
      <p class="g-pstyle7">57<span class="g-cstyle12">8</span><span class="g-cstyle6">,</span>7<span class="g-cstyle4">0</span><span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-197" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:57.1761%;margin-top:-7.2px;left:46.5965%;width:58px;">
      <p class="g-pstyle7">72<span class="g-cstyle4">5</span><span class="g-cstyle17">,</span>7<span class="g-cstyle4">0</span><span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-198" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:57.1761%;margin-top:-7.2px;left:53.6892%;width:45px;">
      <p class="g-pstyle6">3<span class="g-cstyle4">0</span>%<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-199" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:57.1761%;margin-top:-7.2px;left:58.6108%;width:43px;">
      <p class="g-pstyle6">1<span class="g-cstyle4">0</span>%<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-200" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:57.1761%;margin-top:-7.2px;left:64.4639%;width:25px;">
      <p class="g-pstyle8"> </p>
    </div>
    <div id="g-ai0-201" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:57.1761%;margin-top:-7.2px;left:68.3581%;width:43px;">
      <p class="g-pstyle6">1<span class="g-cstyle4">0</span>%<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-202" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:57.1761%;margin-top:-7.2px;left:79.7483%;width:46px;">
      <p class="g-pstyle7">30%<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-203" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:57.1761%;margin-top:-7.2px;left:87.2122%;width:37px;">
      <p class="g-pstyle10"><span class="g-cstyle14">3</span>2<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-204" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:57.1761%;margin-top:-7.2px;left:92.6681%;width:83px;">
      <p class="g-pstyle7"><span class="g-cstyle4">$</span>3<span class="g-cstyle4">.</span>495<span class="g-cstyle13">.</span>00<span class="g-cstyle4">0</span><span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-205" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:57.1761%;margin-top:-7.2px;left:73.5167%;width:45px;">
      <p class="g-pstyle6">2<span class="g-cstyle4">0</span>%<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-206" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:60.5851%;margin-top:-7.7px;left:2.1574%;width:99px;">
      <p class="g-pstyle5"><span class="g-cstyle10">U</span>. de La <span class="g-cstyle4">Se</span><span class="g-cstyle20">r</span>ena<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-207" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:60.7027%;margin-top:-7.2px;left:21.1464%;width:70px;">
      <p class="g-pstyle6">La<span class="g-cstyle4"> </span>S<span class="g-cstyle4">e</span><span class="g-cstyle11">r</span><span class="g-cstyle4">e</span>na<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-208" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:60.7027%;margin-top:-7.2px;left:30.4279%;width:61px;">
      <p class="g-pstyle7">48<span class="g-cstyle7">0</span>,8<span class="g-cstyle4">0</span><span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-209" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:60.7027%;margin-top:-7.2px;left:38.5321%;width:60px;">
      <p class="g-pstyle7">55<span class="g-cstyle12">8</span><span class="g-cstyle4">,</span>43<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-210" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:60.7027%;margin-top:-7.2px;left:46.557%;width:58px;">
      <p class="g-pstyle7">701<span class="g-cstyle9">,</span>60<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-211" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:60.7027%;margin-top:-7.2px;left:53.6892%;width:45px;">
      <p class="g-pstyle6">3<span class="g-cstyle4">0</span>%<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-212" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:60.7027%;margin-top:-7.2px;left:58.6108%;width:43px;">
      <p class="g-pstyle6">1<span class="g-cstyle4">0</span>%<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-213" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:60.7027%;margin-top:-7.2px;left:64.4639%;width:25px;">
      <p class="g-pstyle8"> </p>
    </div>
    <div id="g-ai0-214" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:60.7027%;margin-top:-7.2px;left:68.3188%;width:45px;">
      <p class="g-pstyle6">3<span class="g-cstyle4">0</span>%<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-215" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:60.7027%;margin-top:-7.2px;left:73.5167%;width:45px;">
      <p class="g-pstyle6">2<span class="g-cstyle4">0</span>%<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-216" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:60.7027%;margin-top:-7.2px;left:79.7641%;width:44px;">
      <p class="g-pstyle7">1<span class="g-cstyle4">0</span>%<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-217" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:60.7027%;margin-top:-7.2px;left:87.1965%;width:37px;">
      <p class="g-pstyle10"><span class="g-cstyle14">5</span>0<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-218" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:60.7027%;margin-top:-7.2px;left:92.8339%;width:79px;">
      <p class="g-pstyle7"><span class="g-cstyle4">$</span>3<span class="g-cstyle4">.</span>113<span class="g-cstyle13">.</span>00<span class="g-cstyle4">0</span><span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-219" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:63.8765%;margin-top:-7.7px;left:2.1574%;width:117px;">
      <p class="g-pstyle5"><span class="g-cstyle10">U</span>. Ce<span class="g-cstyle4">nt</span>r<span class="g-cstyle4">a</span>l<span class="g-cstyle4"> </span>de Chi<span class="g-cstyle4">l</span>e*<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-220" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:63.9941%;margin-top:-7.2px;left:21.3832%;width:65px;">
      <p class="g-pstyle6"><span class="g-cstyle4">S</span>anti<span class="g-cstyle4">a</span>g<span class="g-cstyle4">o</span><span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-221" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:63.9941%;margin-top:-7.2px;left:30.4911%;width:58px;">
      <p class="g-pstyle7">471<span class="g-cstyle11">,</span><span class="g-cstyle4">0</span>0<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-222" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:63.9941%;margin-top:-7.2px;left:38.54%;width:58px;">
      <p class="g-pstyle7">53<span class="g-cstyle4">1</span><span class="g-cstyle11">,</span><span class="g-cstyle4">0</span>0<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-223" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:63.9941%;margin-top:-7.2px;left:46.5254%;width:59px;">
      <p class="g-pstyle7">616<span class="g-cstyle9">,</span>0<span class="g-cstyle4">0</span><span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-224" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:63.9941%;margin-top:-7.2px;left:53.6656%;width:45px;">
      <p class="g-pstyle6">4<span class="g-cstyle4">0</span>%<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-225" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:63.9941%;margin-top:-7.2px;left:58.6108%;width:43px;">
      <p class="g-pstyle6">1<span class="g-cstyle4">0</span>%<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-226" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:63.9941%;margin-top:-7.2px;left:63.4846%;width:43px;">
      <p class="g-pstyle6">1<span class="g-cstyle4">0</span>%<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-227" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:63.9941%;margin-top:-7.2px;left:68.3581%;width:43px;">
      <p class="g-pstyle6">1<span class="g-cstyle4">0</span>%<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-228" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:63.9941%;margin-top:-7.2px;left:79.7483%;width:46px;">
      <p class="g-pstyle7">30%<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-229" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:63.9941%;margin-top:-7.2px;left:87.1965%;width:37px;">
      <p class="g-pstyle10"><span class="g-cstyle14">5</span>0<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-230" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:63.9941%;margin-top:-7.2px;left:92.6444%;width:83px;">
      <p class="g-pstyle7"><span class="g-cstyle4">$</span>3<span class="g-cstyle4">.</span>824<span class="g-cstyle13">.</span>0<span class="g-cstyle4">0</span>0<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-231" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:63.9941%;margin-top:-7.2px;left:73.556%;width:43px;">
      <p class="g-pstyle6">1<span class="g-cstyle4">0</span>%<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-232" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:67.1679%;margin-top:-7.7px;left:2.1574%;width:119px;">
      <p class="g-pstyle5"><span class="g-cstyle10">U</span>. de Las<span class="g-cstyle4"> </span>América<span class="g-cstyle4">s</span>*<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-233" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:67.2855%;margin-top:-7.2px;left:68.3581%;width:43px;">
      <p class="g-pstyle6">1<span class="g-cstyle4">0</span>%<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-234" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:67.2855%;margin-top:-7.2px;left:21.3832%;width:65px;">
      <p class="g-pstyle6"><span class="g-cstyle4">S</span>anti<span class="g-cstyle4">a</span>g<span class="g-cstyle4">o</span><span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-235" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:67.2855%;margin-top:-7.2px;left:30.4517%;width:60px;">
      <p class="g-pstyle7">47<span class="g-cstyle7">0</span><span class="g-cstyle11">,</span><span class="g-cstyle4">0</span>0<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-236" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:67.2855%;margin-top:-7.2px;left:38.5875%;width:57px;">
      <p class="g-pstyle7">5<span class="g-cstyle4">2</span>1,<span class="g-cstyle4">5</span>5<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-237" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:67.2855%;margin-top:-7.2px;left:46.5176%;width:60px;">
      <p class="g-pstyle7">59<span class="g-cstyle7">0</span><span class="g-cstyle9">,</span>60<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-238" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:67.2855%;margin-top:-7.2px;left:53.7287%;width:43px;">
      <p class="g-pstyle6">1<span class="g-cstyle4">0</span>%<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-239" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:67.2855%;margin-top:-7.2px;left:58.6108%;width:43px;">
      <p class="g-pstyle6">1<span class="g-cstyle4">0</span>%<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-240" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:67.2855%;margin-top:-7.2px;left:63.4846%;width:43px;">
      <p class="g-pstyle6">1<span class="g-cstyle4">0</span>%<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-241" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:67.2855%;margin-top:-7.2px;left:73.5167%;width:45px;">
      <p class="g-pstyle6">3<span class="g-cstyle4">0</span>%<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-242" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:67.2855%;margin-top:-7.2px;left:79.7167%;width:46px;">
      <p class="g-pstyle7">4<span class="g-cstyle4">0</span>%<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-243" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:67.2855%;margin-top:-7.2px;left:87.1884%;width:38px;">
      <p class="g-pstyle7">30<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-244" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:67.2855%;margin-top:-7.2px;left:92.8103%;width:80px;">
      <p class="g-pstyle7"><span class="g-cstyle4">$</span>3<span class="g-cstyle9">.</span>7<span class="g-cstyle4">2</span>1<span class="g-cstyle9">.</span><span class="g-cstyle4">0</span>00<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-245" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:70.6944%;margin-top:-7.7px;left:2.1574%;width:101px;">
      <p class="g-pstyle5"><span class="g-cstyle10">U</span>. An<span class="g-cstyle4">d</span><span class="g-cstyle20">r</span>és <span class="g-cstyle4">B</span>ello<span class="g-cstyle4">*</span><span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-246" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:70.812%;margin-top:-7.2px;left:21.3832%;width:65px;">
      <p class="g-pstyle6"><span class="g-cstyle4">S</span>anti<span class="g-cstyle4">a</span>g<span class="g-cstyle4">o</span><span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-247" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:70.812%;margin-top:-7.2px;left:30.42%;width:61px;">
      <p class="g-pstyle7">46<span class="g-cstyle11">4,</span>0<span class="g-cstyle4">0</span><span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-248" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:70.812%;margin-top:-7.2px;left:38.5005%;width:60px;">
      <p class="g-pstyle10"><span class="g-cstyle14">5</span>2<span class="g-cstyle12">8</span><span class="g-cstyle11">,</span>0<span class="g-cstyle14">0</span><span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-249" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:70.812%;margin-top:-7.2px;left:46.5096%;width:60px;">
      <p class="g-pstyle7">596<span class="g-cstyle9">,</span>0<span class="g-cstyle4">0</span><span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-250" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:70.812%;margin-top:-7.2px;left:53.7209%;width:45px;">
      <p class="g-pstyle6">35%<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-251" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:70.812%;margin-top:-7.2px;left:58.6424%;width:43px;">
      <p class="g-pstyle6">15%<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-252" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:70.812%;margin-top:-7.2px;left:63.445%;width:45px;">
      <p class="g-pstyle6">3<span class="g-cstyle4">0</span>%<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-253" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:70.812%;margin-top:-7.2px;left:68.3188%;width:45px;">
      <p class="g-pstyle6">3<span class="g-cstyle4">0</span>%<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-254" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:70.812%;margin-top:-7.2px;left:73.556%;width:43px;">
      <p class="g-pstyle6">1<span class="g-cstyle4">0</span>%<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-255" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:70.812%;margin-top:-7.2px;left:79.7641%;width:44px;">
      <p class="g-pstyle7">1<span class="g-cstyle4">0</span>%<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-256" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:70.812%;margin-top:-7.2px;left:87.2043%;width:37px;">
      <p class="g-pstyle7">85<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-257" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:70.812%;margin-top:-7.2px;left:92.6523%;width:83px;">
      <p class="g-pstyle7"><span class="g-cstyle4">$</span>5<span class="g-cstyle4">.</span>49<span class="g-cstyle4">2</span><span class="g-cstyle9">.</span><span class="g-cstyle4">0</span>00<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-258" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:73.9858%;margin-top:-7.7px;left:2.1574%;width:132px;">
      <p class="g-pstyle5"><span class="g-cstyle10">U</span>. Be<span class="g-cstyle4">r</span>nard<span class="g-cstyle4">o</span> O&rsquo;Higgins*<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-259" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:74.1034%;margin-top:-7.2px;left:21.3832%;width:65px;">
      <p class="g-pstyle6"><span class="g-cstyle4">S</span>anti<span class="g-cstyle4">a</span>g<span class="g-cstyle4">o</span><span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-260" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:74.1034%;margin-top:-7.2px;left:30.4359%;width:60px;">
      <p class="g-pstyle7">462,4<span class="g-cstyle4">0</span><span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-261" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:74.1034%;margin-top:-7.2px;left:38.548%;width:58px;">
      <p class="g-pstyle7">51<span class="g-cstyle12">8</span><span class="g-cstyle4">,</span>54<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-262" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:74.1034%;margin-top:-7.2px;left:46.5648%;width:59px;">
      <p class="g-pstyle7">596<span class="g-cstyle4">,</span>35<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-263" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:74.1034%;margin-top:-7.2px;left:53.7209%;width:45px;">
      <p class="g-pstyle6">25%<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-264" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:74.1034%;margin-top:-7.2px;left:58.6108%;width:43px;">
      <p class="g-pstyle6">1<span class="g-cstyle4">0</span>%<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-265" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:74.1034%;margin-top:-7.2px;left:63.5161%;width:43px;">
      <p class="g-pstyle6">15%<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-266" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:74.1034%;margin-top:-7.2px;left:68.3976%;width:43px;">
      <p class="g-pstyle6">15%<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-267" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:74.1034%;margin-top:-7.2px;left:79.7719%;width:45px;">
      <p class="g-pstyle7"><span class="g-cstyle4">2</span>5%<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-268" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:74.1034%;margin-top:-7.2px;left:87.1805%;width:37px;">
      <p class="g-pstyle7"><span class="g-cstyle4">2</span>0<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-269" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:74.1034%;margin-top:-7.2px;left:92.6523%;width:83px;">
      <p class="g-pstyle7"><span class="g-cstyle4">$</span>3<span class="g-cstyle4">.</span>34<span class="g-cstyle9">0</span><span class="g-cstyle13">.</span>0<span class="g-cstyle4">0</span>0<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-270" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:74.1034%;margin-top:-7.2px;left:73.5481%;width:45px;">
      <p class="g-pstyle6">25%<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-271" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:77.5123%;margin-top:-7.7px;left:2.1574%;width:131px;">
      <p class="g-pstyle5"><span class="g-cstyle10">U</span>. Aut<span class="g-cstyle4">ó</span>n<span class="g-cstyle4">o</span>m<span class="g-cstyle4">a</span> de Ch<span class="g-cstyle4">i</span>le*<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-272" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:77.6299%;margin-top:-7.2px;left:21.3832%;width:65px;">
      <p class="g-pstyle6"><span class="g-cstyle4">S</span>anti<span class="g-cstyle4">a</span>g<span class="g-cstyle4">o</span><span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-273" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:77.6299%;margin-top:-7.2px;left:30.4438%;width:60px;">
      <p class="g-pstyle7">4<span class="g-cstyle4">5</span><span class="g-cstyle12">8</span><span class="g-cstyle4">,</span>40<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-274" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:77.6299%;margin-top:-7.2px;left:38.4769%;width:60px;">
      <p class="g-pstyle7">496<span class="g-cstyle4">,</span>2<span class="g-cstyle4">0</span><span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-275" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:77.6299%;margin-top:-7.2px;left:46.5412%;width:59px;">
      <p class="g-pstyle7">5<span class="g-cstyle6">7</span><span class="g-cstyle9">4</span>,80<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-276" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:77.6299%;margin-top:-7.2px;left:53.6892%;width:45px;">
      <p class="g-pstyle6">3<span class="g-cstyle4">0</span>%<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-277" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:77.6299%;margin-top:-7.2px;left:58.5634%;width:45px;">
      <p class="g-pstyle6">2<span class="g-cstyle4">0</span>%<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-278" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:77.6299%;margin-top:-7.2px;left:63.4846%;width:43px;">
      <p class="g-pstyle6">1<span class="g-cstyle4">0</span>%<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-279" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:77.6299%;margin-top:-7.2px;left:68.3581%;width:43px;">
      <p class="g-pstyle6">1<span class="g-cstyle4">0</span>%<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-280" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:77.6299%;margin-top:-7.2px;left:73.556%;width:43px;">
      <p class="g-pstyle6">1<span class="g-cstyle4">0</span>%<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-281" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:77.6299%;margin-top:-7.2px;left:79.7483%;width:46px;">
      <p class="g-pstyle7">30%<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-282" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:77.6299%;margin-top:-7.2px;left:87.1965%;width:37px;">
      <p class="g-pstyle10"><span class="g-cstyle14">5</span>0<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-283" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:77.6299%;margin-top:-7.2px;left:92.7235%;width:81px;">
      <p class="g-pstyle7"><span class="g-cstyle4">$</span>4<span class="g-cstyle4">.</span>2<span class="g-cstyle4">1</span>3<span class="g-cstyle9">.</span><span class="g-cstyle4">0</span>00<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-284" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:80.8037%;margin-top:-7.7px;left:2.1574%;width:108px;">
      <p class="g-pstyle5"><span class="g-cstyle10">U</span>. Au<span class="g-cstyle4">s</span>tral<span class="g-cstyle4"> </span>de Chi<span class="g-cstyle4">l</span><span class="g-cstyle0">e</span></p>
    </div>
    <div id="g-ai0-285" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:80.9213%;margin-top:-7.2px;left:21.6676%;width:57px;">
      <p class="g-pstyle6"><span class="g-cstyle16">V</span>aldiv<span class="g-cstyle4">i</span><span class="g-cstyle0">a</span></p>
    </div>
    <div id="g-ai0-286" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:80.9213%;margin-top:-7.2px;left:30.4279%;width:58px;">
      <p class="g-pstyle10"><span class="g-cstyle14">4</span>4<span class="g-cstyle11">4</span><span class="g-cstyle14">,</span>2<span class="g-cstyle0">0</span></p>
    </div>
    <div id="g-ai0-287" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:80.9213%;margin-top:-7.2px;left:38.5717%;width:55px;">
      <p class="g-pstyle7">581<span class="g-cstyle24">,</span>9<span class="g-cstyle0">7</span></p>
    </div>
    <div id="g-ai0-288" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:80.9213%;margin-top:-7.2px;left:46.644%;width:54px;">
      <p class="g-pstyle7">71<span class="g-cstyle18">9</span><span class="g-cstyle6">,</span>7<span class="g-cstyle0">5</span></p>
    </div>
    <div id="g-ai0-289" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:80.9213%;margin-top:-7.2px;left:53.7209%;width:45px;">
      <p class="g-pstyle6">25%<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-290" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:80.9213%;margin-top:-7.2px;left:58.6108%;width:41px;">
      <p class="g-pstyle9"><span class="g-cstyle14">1</span>0<span class="g-cstyle0">%</span></p>
    </div>
    <div id="g-ai0-291" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:80.9213%;margin-top:-7.2px;left:63.4846%;width:43px;">
      <p class="g-pstyle6">1<span class="g-cstyle4">0</span>%<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-292" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:80.9213%;margin-top:-7.2px;left:68.3976%;width:43px;">
      <p class="g-pstyle6">15%<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-293" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:80.9213%;margin-top:-7.2px;left:79.7167%;width:46px;">
      <p class="g-pstyle7">4<span class="g-cstyle4">0</span>%<span class="g-cstyle0"> </span></p>
    </div>
    <div id="g-ai0-294" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:80.9213%;margin-top:-7.2px;left:87.1805%;width:35px;">
      <p class="g-pstyle11"><span class="g-cstyle14">4</span>2</p>
    </div>
    <div id="g-ai0-295" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:80.9213%;margin-top:-7.2px;left:92.6759%;width:81px;">
      <p class="g-pstyle7"><span class="g-cstyle4">$</span>3<span class="g-cstyle4">.</span>298<span class="g-cstyle13">.</span>0<span class="g-cstyle4">0</span><span class="g-cstyle0">0</span></p>
    </div>
    <div id="g-ai0-296" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:80.9213%;margin-top:-7.2px;left:73.556%;width:41px;">
      <p class="g-pstyle9"><span class="g-cstyle14">1</span>0<span class="g-cstyle0">%</span></p>
    </div>
    <div id="g-ai0-297" class="g-Layer_1 g-aiAbs" style="top:83.9309%;left:1.4894%;width:97.5532%;">
      <p class="g-pstyle12">Fuente: Información proporcionada por cada casa de estudio, la cual corresponde a la jornada diurna / En algunos casos los aranceles y vacantes corresponden al año 2021 / (*) Piden una de las dos pruebas optativas / La información de la U. de Santiago de Chile fue extraída de su portal (www.usach.cl), donde se señala que los puntajes de ingreso corresponden al último seleccionado y los aranceles a los deciles 7, 8 y 9 / La UNIACC &mdash;Santiago, 50 vacantes vespertino, $2.950.000, y 40 semipresencial, $2.590.000&mdash;, no considera los resultados de la PDT en su proceso de selección</p>
    </div>
  </div>

  <!-- Artboard: mobile -->
  <div id="g-periodismo-mobile" class="g-artboard" style="max-width: 320px;max-height: 1221px" data-aspect-ratio="0.262" data-min-width="0" data-max-width="939">
<div style="padding: 0 0 381.5625% 0;"></div>
    <img id="g-periodismo-mobile-img" class="g-aiImg" alt="" src="${img1}"/>
    <div id="g-ai1-1" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:2.5229%;margin-top:-10.8px;left:75.9566%;width:47px;">
      <p class="g-pstyle0">Prom </p>
      <p class="g-pstyle0">P<span class="g-cstyle0">o</span>n<span class="g-cstyle1">d</span></p>
    </div>
    <div id="g-ai1-2" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:2.6186%;margin-top:-8px;left:2.1016%;width:90px;">
      <p class="g-pstyle1">Univ<span class="g-cstyle0">e</span>r<span class="g-cstyle0">s</span>ida<span class="g-cstyle1">d</span></p>
    </div>
    <div id="g-ai1-3" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:2.6555%;margin-top:-6.4px;left:45.8052%;width:44px;">
      <p class="g-pstyle2">Sed<span class="g-cstyle1">e</span></p>
    </div>
    <div id="g-ai1-4" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:2.6555%;margin-top:-6.4px;left:58.3714%;width:63px;">
      <p class="g-pstyle2">M<span class="g-cstyle2">í</span>n <span class="g-cstyle0">P</span>o<span class="g-cstyle0">n</span><span class="g-cstyle1">d</span></p>
    </div>
    <div id="g-ai1-5" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:2.6555%;margin-top:-6.4px;left:85.4601%;width:65px;">
      <p class="g-pstyle2"><span class="g-cstyle0">M</span>áx Po<span class="g-cstyle0">n</span><span class="g-cstyle1">d</span></p>
    </div>
    <div id="g-ai1-6" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:4.7255%;margin-top:-7.7px;left:1.9624%;width:87px;">
      <p class="g-pstyle3">PUC de<span class="g-cstyle3"> </span>Ch<span class="g-cstyle3">i</span>le<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-7" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:4.7665%;margin-top:-7.2px;left:43.4383%;width:65px;">
      <p class="g-pstyle4"><span class="g-cstyle3">S</span>anti<span class="g-cstyle3">a</span>g<span class="g-cstyle3">o</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-8" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:4.7665%;margin-top:-7.2px;left:59.9266%;width:59px;">
      <p class="g-pstyle5">66<span class="g-cstyle4">7</span><span class="g-cstyle3">,8</span>0<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-9" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:4.7665%;margin-top:-7.2px;left:74.5778%;width:57px;">
      <p class="g-pstyle5">701<span class="g-cstyle5">,</span>76<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-10" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:4.7665%;margin-top:-7.2px;left:87.2932%;width:60px;">
      <p class="g-pstyle5">78<span class="g-cstyle6">0</span><span class="g-cstyle7">,</span>9<span class="g-cstyle3">0</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-11" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:5.8722%;margin-top:-7.7px;left:1.9624%;width:75px;">
      <p class="g-pstyle3"><span class="g-cstyle8">U</span>. de C<span class="g-cstyle3">h</span>i<span class="g-cstyle3">le</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-12" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:5.9131%;margin-top:-7.2px;left:43.4383%;width:65px;">
      <p class="g-pstyle4"><span class="g-cstyle3">S</span>anti<span class="g-cstyle3">a</span>g<span class="g-cstyle3">o</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-13" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:5.9131%;margin-top:-7.2px;left:59.9727%;width:59px;">
      <p class="g-pstyle5">63<span class="g-cstyle4">7</span><span class="g-cstyle9">,</span><span class="g-cstyle3">0</span>0<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-14" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:5.9131%;margin-top:-7.2px;left:74.4612%;width:59px;">
      <p class="g-pstyle5">67<span class="g-cstyle10">3</span>,3<span class="g-cstyle3">0</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-15" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:5.9131%;margin-top:-7.2px;left:87.4559%;width:57px;">
      <p class="g-pstyle5">791,<span class="g-cstyle3">5</span>0<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-16" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:7.1006%;margin-top:-7.7px;left:1.9624%;width:134px;">
      <p class="g-pstyle3"><span class="g-cstyle8">U</span>. de San<span class="g-cstyle3">ti</span>ago de Chile<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-17" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:7.1415%;margin-top:-7.2px;left:43.4383%;width:65px;">
      <p class="g-pstyle4"><span class="g-cstyle3">S</span>anti<span class="g-cstyle3">a</span>g<span class="g-cstyle3">o</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-18" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:7.1415%;margin-top:-7.2px;left:59.7411%;width:61px;">
      <p class="g-pstyle5">6<span class="g-cstyle3">0</span><span class="g-cstyle6">0</span><span class="g-cstyle7">,</span>90<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-19" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:7.1415%;margin-top:-7.2px;left:77.6173%;width:36px;">
      <p class="g-pstyle5">s/<span class="g-cstyle3">i</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-20" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:7.1415%;margin-top:-7.2px;left:87.2704%;width:60px;">
      <p class="g-pstyle5">696<span class="g-cstyle3">,</span>50<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-21" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:8.2472%;margin-top:-7.7px;left:1.9624%;width:107px;">
      <p class="g-pstyle3"><span class="g-cstyle8">U</span>. Ad<span class="g-cstyle3">o</span>lfo<span class="g-cstyle3"> </span>Ibáñez*<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-22" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:8.2881%;margin-top:-7.2px;left:43.4383%;width:65px;">
      <p class="g-pstyle4"><span class="g-cstyle3">S</span>anti<span class="g-cstyle3">a</span>g<span class="g-cstyle3">o</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-23" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:8.2881%;margin-top:-7.2px;left:59.8338%;width:60px;">
      <p class="g-pstyle5">592<span class="g-cstyle11">,</span>00<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-24" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:8.2881%;margin-top:-7.2px;left:74.276%;width:60px;">
      <p class="g-pstyle5">64<span class="g-cstyle6">0</span><span class="g-cstyle3">,</span>28<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-25" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:8.2881%;margin-top:-7.2px;left:87.3167%;width:59px;">
      <p class="g-pstyle5">726<span class="g-cstyle9">,</span><span class="g-cstyle3">0</span>0<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-26" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:9.3939%;margin-top:-7.7px;left:1.9624%;width:108px;">
      <p class="g-pstyle3"><span class="g-cstyle8">U</span>. de C<span class="g-cstyle3">o</span>ncepción<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-27" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:9.4347%;margin-top:-7.2px;left:40.8626%;width:79px;">
      <p class="g-pstyle6">Co<span class="g-cstyle12">n</span>ce<span class="g-cstyle12">p</span>ció<span class="g-cstyle12">n</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-28" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:9.4347%;margin-top:-7.2px;left:59.857%;width:60px;">
      <p class="g-pstyle5">56<span class="g-cstyle6">0</span>,4<span class="g-cstyle3">5</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-29" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:9.4347%;margin-top:-7.2px;left:74.3687%;width:59px;">
      <p class="g-pstyle5">60<span class="g-cstyle4">7</span>,4<span class="g-cstyle3">0</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-30" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:9.4347%;margin-top:-7.2px;left:87.3628%;width:60px;">
      <p class="g-pstyle5">68<span class="g-cstyle10">8</span>,35<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-31" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:10.6224%;margin-top:-7.7px;left:1.9624%;width:117px;">
      <p class="g-pstyle3">PUC de<span class="g-cstyle3"> </span><span class="g-cstyle13">V</span>alp<span class="g-cstyle3">a</span>raíso<span class="g-cstyle3">*</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-32" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:10.6633%;margin-top:-7.2px;left:42.4174%;width:72px;">
      <p class="g-pstyle4"><span class="g-cstyle14">V</span>alpar<span class="g-cstyle3">a</span>í<span class="g-cstyle3">s</span>o<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-33" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:10.6633%;margin-top:-7.2px;left:60.0655%;width:58px;">
      <p class="g-pstyle7"><span class="g-cstyle12">5</span>4<span class="g-cstyle4">7</span><span class="g-cstyle15">,</span><span class="g-cstyle12">7</span>0<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-34" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:10.6633%;margin-top:-7.2px;left:74.3452%;width:60px;">
      <p class="g-pstyle5">60<span class="g-cstyle10">3</span><span class="g-cstyle3">,</span>30<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-35" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:10.6633%;margin-top:-7.2px;left:87.3167%;width:59px;">
      <p class="g-pstyle5">72<span class="g-cstyle16">9</span>,4<span class="g-cstyle3">0</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-36" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:11.769%;margin-top:-7.7px;left:1.9624%;width:103px;">
      <p class="g-pstyle3"><span class="g-cstyle8">U</span>. de los <span class="g-cstyle3">A</span>ndes*<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-37" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:11.8098%;margin-top:-7.2px;left:43.4383%;width:65px;">
      <p class="g-pstyle4"><span class="g-cstyle3">S</span>anti<span class="g-cstyle3">a</span>g<span class="g-cstyle3">o</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-38" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:11.8098%;margin-top:-7.2px;left:59.8338%;width:60px;">
      <p class="g-pstyle5">5<span class="g-cstyle3">4</span><span class="g-cstyle10">3</span>,80<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-39" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:11.8098%;margin-top:-7.2px;left:74.2528%;width:60px;">
      <p class="g-pstyle5">60<span class="g-cstyle3">2</span><span class="g-cstyle11">,</span>00<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-40" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:11.8098%;margin-top:-7.2px;left:87.4559%;width:59px;">
      <p class="g-pstyle5">736<span class="g-cstyle5">,</span>70<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-41" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:12.9975%;margin-top:-7.7px;left:1.9624%;width:110px;">
      <p class="g-pstyle3"><span class="g-cstyle8">U</span>. Di<span class="g-cstyle3">eg</span>o<span class="g-cstyle3"> </span>P<span class="g-cstyle3">o</span>rtale<span class="g-cstyle3">s</span>*<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-42" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:13.0384%;margin-top:-7.2px;left:43.4383%;width:65px;">
      <p class="g-pstyle4"><span class="g-cstyle3">S</span>anti<span class="g-cstyle3">a</span>g<span class="g-cstyle3">o</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-43" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:13.0384%;margin-top:-7.2px;left:59.8802%;width:60px;">
      <p class="g-pstyle5">536<span class="g-cstyle9">,</span>6<span class="g-cstyle3">0</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-44" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:13.0384%;margin-top:-7.2px;left:74.4151%;width:60px;">
      <p class="g-pstyle5">585<span class="g-cstyle3">,</span>88<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-45" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:13.0384%;margin-top:-7.2px;left:87.2469%;width:60px;">
      <p class="g-pstyle5">66<span class="g-cstyle3">2</span>,8<span class="g-cstyle3">0</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-46" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:14.1441%;margin-top:-7.7px;left:1.9624%;width:140px;">
      <p class="g-pstyle3">UC <span class="g-cstyle3">d</span>e<span class="g-cstyle3"> </span>la<span class="g-cstyle3"> </span>S. C<span class="g-cstyle3">o</span>n<span class="g-cstyle3">c</span>epció<span class="g-cstyle3">n</span>*<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-47" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:14.185%;margin-top:-7.2px;left:40.8626%;width:79px;">
      <p class="g-pstyle6">Co<span class="g-cstyle12">n</span>ce<span class="g-cstyle12">p</span>ció<span class="g-cstyle12">n</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-48" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:14.185%;margin-top:-7.2px;left:60.0426%;width:58px;">
      <p class="g-pstyle5">535<span class="g-cstyle3">,</span>10<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-49" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:14.185%;margin-top:-7.2px;left:74.3452%;width:60px;">
      <p class="g-pstyle5">58<span class="g-cstyle10">8</span>,8<span class="g-cstyle3">9</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-50" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:14.185%;margin-top:-7.2px;left:87.433%;width:58px;">
      <p class="g-pstyle5">71<span class="g-cstyle11">4</span>,5<span class="g-cstyle3">0</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-51" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:15.2907%;margin-top:-7.7px;left:1.9624%;width:117px;">
      <p class="g-pstyle3"><span class="g-cstyle8">U</span>. Alber<span class="g-cstyle3">t</span>o Hurta<span class="g-cstyle3">d</span>o*<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-52" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:15.3316%;margin-top:-7.2px;left:43.4383%;width:65px;">
      <p class="g-pstyle4"><span class="g-cstyle3">S</span>anti<span class="g-cstyle3">a</span>g<span class="g-cstyle3">o</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-53" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:15.3316%;margin-top:-7.2px;left:59.9498%;width:58px;">
      <p class="g-pstyle7"><span class="g-cstyle12">5</span>1<span class="g-cstyle10">3</span><span class="g-cstyle9">,</span>0<span class="g-cstyle12">0</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-54" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:15.3316%;margin-top:-7.2px;left:74.2989%;width:61px;">
      <p class="g-pstyle5">56<span class="g-cstyle6">0</span><span class="g-cstyle11">,</span>0<span class="g-cstyle3">0</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-55" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:15.3316%;margin-top:-7.2px;left:87.224%;width:60px;">
      <p class="g-pstyle5">66<span class="g-cstyle16">9</span><span class="g-cstyle11">,</span><span class="g-cstyle3">0</span>0<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-56" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:16.5191%;margin-top:-7.7px;left:1.9624%;width:105px;">
      <p class="g-pstyle3"><span class="g-cstyle8">U</span>. de La <span class="g-cstyle17">F</span><span class="g-cstyle18">r</span>o<span class="g-cstyle3">n</span>tera<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-57" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:16.5601%;margin-top:-7.2px;left:43.6937%;width:61px;">
      <p class="g-pstyle4"><span class="g-cstyle19">T</span>emu<span class="g-cstyle3">co</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-58" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:16.5601%;margin-top:-7.2px;left:59.9266%;width:58px;">
      <p class="g-pstyle5">5<span class="g-cstyle3">1</span><span class="g-cstyle6">0</span><span class="g-cstyle7">,</span>90<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-59" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:16.5601%;margin-top:-7.2px;left:74.6007%;width:57px;">
      <p class="g-pstyle5">56<span class="g-cstyle16">9</span><span class="g-cstyle15">,</span>71<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-60" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:16.5601%;margin-top:-7.2px;left:87.4794%;width:58px;">
      <p class="g-pstyle5">67<span class="g-cstyle10">3</span>,<span class="g-cstyle3">1</span>0<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-61" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:17.6657%;margin-top:-7.7px;left:1.9624%;width:106px;">
      <p class="g-pstyle3"><span class="g-cstyle8">U</span>. de<span class="g-cstyle3">l</span> De<span class="g-cstyle3">s</span>a<span class="g-cstyle3">r</span><span class="g-cstyle18">r</span><span class="g-cstyle3">o</span>ll<span class="g-cstyle3">o</span>*<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-62" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:17.7067%;margin-top:-7.2px;left:43.4383%;width:65px;">
      <p class="g-pstyle4"><span class="g-cstyle3">S</span>anti<span class="g-cstyle3">a</span>g<span class="g-cstyle3">o</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-63" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:17.7067%;margin-top:-7.2px;left:59.9034%;width:58px;">
      <p class="g-pstyle5">5<span class="g-cstyle3">01</span><span class="g-cstyle7">,</span>90<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-64" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:17.7067%;margin-top:-7.2px;left:74.3916%;width:60px;">
      <p class="g-pstyle5">57<span class="g-cstyle10">8</span><span class="g-cstyle11">,</span>00<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-65" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:17.7067%;margin-top:-7.2px;left:87.4092%;width:59px;">
      <p class="g-pstyle5">72<span class="g-cstyle3">5</span><span class="g-cstyle9">,</span>6<span class="g-cstyle3">0</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-66" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:18.8942%;margin-top:-7.7px;left:1.9624%;width:96px;">
      <p class="g-pstyle3"><span class="g-cstyle8">U</span>. Fi<span class="g-cstyle3">n</span>is <span class="g-cstyle20">T</span>erra<span class="g-cstyle3">e</span>*<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-67" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:18.9352%;margin-top:-7.2px;left:43.4383%;width:65px;">
      <p class="g-pstyle4"><span class="g-cstyle3">S</span>anti<span class="g-cstyle3">a</span>g<span class="g-cstyle3">o</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-68" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:18.9352%;margin-top:-7.2px;left:59.9034%;width:58px;">
      <p class="g-pstyle5">5<span class="g-cstyle3">01</span><span class="g-cstyle7">,</span>90<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-69" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:18.9352%;margin-top:-7.2px;left:74.2528%;width:60px;">
      <p class="g-pstyle5">54<span class="g-cstyle11">4</span>,<span class="g-cstyle3">4</span>9<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-70" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:18.9352%;margin-top:-7.2px;left:87.433%;width:58px;">
      <p class="g-pstyle5">61<span class="g-cstyle3">5</span>,50<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-71" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:20.0408%;margin-top:-7.7px;left:1.9624%;width:121px;">
      <p class="g-pstyle3"><span class="g-cstyle8">U</span>. C<span class="g-cstyle21">a</span>tólic<span class="g-cstyle3">a</span> del Norte<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-72" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:20.0818%;margin-top:-7.2px;left:41.2569%;width:80px;">
      <p class="g-pstyle4">Ant<span class="g-cstyle18">o</span>fa<span class="g-cstyle3">g</span>a<span class="g-cstyle3">s</span>ta<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-73" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:20.0818%;margin-top:-7.2px;left:59.7874%;width:60px;">
      <p class="g-pstyle7"><span class="g-cstyle12">5</span>0<span class="g-cstyle6">0</span><span class="g-cstyle7">,</span><span class="g-cstyle12">9</span>0<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-74" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:20.0818%;margin-top:-7.2px;left:74.5314%;width:58px;">
      <p class="g-pstyle5">57<span class="g-cstyle10">8</span><span class="g-cstyle5">,</span>7<span class="g-cstyle3">0</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-75" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:20.0818%;margin-top:-7.2px;left:87.5023%;width:58px;">
      <p class="g-pstyle5">72<span class="g-cstyle3">5</span><span class="g-cstyle15">,</span>7<span class="g-cstyle3">0</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-76" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:21.1874%;margin-top:-7.7px;left:1.9624%;width:99px;">
      <p class="g-pstyle3"><span class="g-cstyle8">U</span>. de La <span class="g-cstyle3">Se</span><span class="g-cstyle18">r</span>ena<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-77" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:21.2284%;margin-top:-7.2px;left:42.7425%;width:70px;">
      <p class="g-pstyle4">La<span class="g-cstyle3"> </span>S<span class="g-cstyle3">e</span><span class="g-cstyle9">r</span><span class="g-cstyle3">e</span>na<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-78" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:21.2284%;margin-top:-7.2px;left:59.6944%;width:61px;">
      <p class="g-pstyle5">48<span class="g-cstyle6">0</span>,8<span class="g-cstyle3">0</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-79" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:21.2284%;margin-top:-7.2px;left:74.438%;width:60px;">
      <p class="g-pstyle5">55<span class="g-cstyle10">8</span><span class="g-cstyle3">,</span>43<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-80" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:21.2284%;margin-top:-7.2px;left:87.3863%;width:58px;">
      <p class="g-pstyle5">701<span class="g-cstyle11">,</span>60<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-81" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:22.4159%;margin-top:-7.7px;left:1.9624%;width:117px;">
      <p class="g-pstyle3"><span class="g-cstyle8">U</span>. Ce<span class="g-cstyle3">nt</span>r<span class="g-cstyle3">a</span>l<span class="g-cstyle3"> </span>de Chi<span class="g-cstyle3">l</span>e*<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-82" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:22.4569%;margin-top:-7.2px;left:43.4383%;width:65px;">
      <p class="g-pstyle4"><span class="g-cstyle3">S</span>anti<span class="g-cstyle3">a</span>g<span class="g-cstyle3">o</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-83" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:22.4569%;margin-top:-7.2px;left:59.8802%;width:58px;">
      <p class="g-pstyle5">471<span class="g-cstyle9">,</span><span class="g-cstyle3">0</span>0<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-84" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:22.4569%;margin-top:-7.2px;left:74.4612%;width:58px;">
      <p class="g-pstyle5">53<span class="g-cstyle3">1</span><span class="g-cstyle9">,</span><span class="g-cstyle3">0</span>0<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-85" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:22.4569%;margin-top:-7.2px;left:87.2932%;width:59px;">
      <p class="g-pstyle5">616<span class="g-cstyle11">,</span>0<span class="g-cstyle3">0</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-86" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:23.5625%;margin-top:-7.7px;left:1.9624%;width:119px;">
      <p class="g-pstyle3"><span class="g-cstyle8">U</span>. de Las<span class="g-cstyle3"> </span>América<span class="g-cstyle3">s</span>*<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-87" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:23.6035%;margin-top:-7.2px;left:43.4383%;width:65px;">
      <p class="g-pstyle4"><span class="g-cstyle3">S</span>anti<span class="g-cstyle3">a</span>g<span class="g-cstyle3">o</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-88" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:23.6035%;margin-top:-7.2px;left:59.7643%;width:60px;">
      <p class="g-pstyle5">47<span class="g-cstyle6">0</span><span class="g-cstyle9">,</span><span class="g-cstyle3">0</span>0<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-89" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:23.6035%;margin-top:-7.2px;left:74.6007%;width:57px;">
      <p class="g-pstyle5">5<span class="g-cstyle3">2</span>1,<span class="g-cstyle3">5</span>5<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-90" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:23.6035%;margin-top:-7.2px;left:87.2704%;width:60px;">
      <p class="g-pstyle5">59<span class="g-cstyle6">0</span><span class="g-cstyle11">,</span>60<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-91" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:24.7911%;margin-top:-7.7px;left:1.9624%;width:101px;">
      <p class="g-pstyle3"><span class="g-cstyle8">U</span>. An<span class="g-cstyle3">d</span><span class="g-cstyle18">r</span>és <span class="g-cstyle3">B</span>ello<span class="g-cstyle3">*</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-92" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:24.832%;margin-top:-7.2px;left:43.4383%;width:65px;">
      <p class="g-pstyle4"><span class="g-cstyle3">S</span>anti<span class="g-cstyle3">a</span>g<span class="g-cstyle3">o</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-93" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:24.832%;margin-top:-7.2px;left:59.6712%;width:61px;">
      <p class="g-pstyle5">46<span class="g-cstyle9">4,</span>0<span class="g-cstyle3">0</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-94" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:24.832%;margin-top:-7.2px;left:74.3452%;width:60px;">
      <p class="g-pstyle7"><span class="g-cstyle12">5</span>2<span class="g-cstyle10">8</span><span class="g-cstyle9">,</span>0<span class="g-cstyle12">0</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-95" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:24.832%;margin-top:-7.2px;left:87.2469%;width:60px;">
      <p class="g-pstyle5">596<span class="g-cstyle11">,</span>0<span class="g-cstyle3">0</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-96" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:25.9377%;margin-top:-7.7px;left:1.9624%;width:132px;">
      <p class="g-pstyle3"><span class="g-cstyle8">U</span>. Be<span class="g-cstyle3">r</span>nard<span class="g-cstyle3">o</span> O&rsquo;Higgins*<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-97" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:25.9786%;margin-top:-7.2px;left:43.4383%;width:65px;">
      <p class="g-pstyle4"><span class="g-cstyle3">S</span>anti<span class="g-cstyle3">a</span>g<span class="g-cstyle3">o</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-98" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:25.9786%;margin-top:-7.2px;left:59.7179%;width:60px;">
      <p class="g-pstyle5">462,4<span class="g-cstyle3">0</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-99" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:25.9786%;margin-top:-7.2px;left:74.4847%;width:58px;">
      <p class="g-pstyle5">51<span class="g-cstyle10">8</span><span class="g-cstyle3">,</span>54<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-100" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:25.9786%;margin-top:-7.2px;left:87.4092%;width:59px;">
      <p class="g-pstyle5">596<span class="g-cstyle3">,</span>35<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-101" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:27.0843%;margin-top:-7.7px;left:1.9624%;width:131px;">
      <p class="g-pstyle3"><span class="g-cstyle8">U</span>. Aut<span class="g-cstyle3">ó</span>n<span class="g-cstyle3">o</span>m<span class="g-cstyle3">a</span> de Ch<span class="g-cstyle3">i</span>le*<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-102" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:27.2071%;margin-top:-7.2px;left:43.4383%;width:65px;">
      <p class="g-pstyle4"><span class="g-cstyle3">S</span>anti<span class="g-cstyle3">a</span>g<span class="g-cstyle3">o</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-103" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:27.2071%;margin-top:-7.2px;left:59.7411%;width:60px;">
      <p class="g-pstyle5">4<span class="g-cstyle3">5</span><span class="g-cstyle10">8</span><span class="g-cstyle3">,</span>40<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-104" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:27.2071%;margin-top:-7.2px;left:74.276%;width:60px;">
      <p class="g-pstyle5">496<span class="g-cstyle3">,</span>2<span class="g-cstyle3">0</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-105" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:27.2071%;margin-top:-7.2px;left:87.3396%;width:59px;">
      <p class="g-pstyle5">5<span class="g-cstyle5">7</span><span class="g-cstyle11">4</span>,80<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-106" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:28.3128%;margin-top:-7.7px;left:1.9624%;width:108px;">
      <p class="g-pstyle3"><span class="g-cstyle8">U</span>. Au<span class="g-cstyle3">s</span>tral<span class="g-cstyle3"> </span>de Chi<span class="g-cstyle3">l</span><span class="g-cstyle1">e</span></p>
    </div>
    <div id="g-ai1-107" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:28.3537%;margin-top:-7.2px;left:44.2735%;width:57px;">
      <p class="g-pstyle4"><span class="g-cstyle14">V</span>aldiv<span class="g-cstyle3">i</span><span class="g-cstyle1">a</span></p>
    </div>
    <div id="g-ai1-108" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:28.3537%;margin-top:-7.2px;left:59.6944%;width:58px;">
      <p class="g-pstyle7"><span class="g-cstyle12">4</span>4<span class="g-cstyle9">4</span><span class="g-cstyle12">,</span>2<span class="g-cstyle1">0</span></p>
    </div>
    <div id="g-ai1-109" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:28.3537%;margin-top:-7.2px;left:74.5543%;width:55px;">
      <p class="g-pstyle5">581<span class="g-cstyle22">,</span>9<span class="g-cstyle1">7</span></p>
    </div>
    <div id="g-ai1-110" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:28.3537%;margin-top:-7.2px;left:87.6418%;width:54px;">
      <p class="g-pstyle5">71<span class="g-cstyle16">9</span><span class="g-cstyle5">,</span>7<span class="g-cstyle1">5</span></p>
    </div>
    <div id="g-ai1-111" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:31.0748%;margin-top:-6.4px;left:44.6338%;width:40px;">
      <p class="g-pstyle8">PD<span class="g-cstyle1">T</span></p>
    </div>
    <div id="g-ai1-112" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:31.0748%;margin-top:-6.4px;left:50.4572%;width:24px;">
      <p class="g-pstyle9"> </p>
    </div>
    <div id="g-ai1-113" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:31.0748%;margin-top:-6.4px;left:55.8252%;width:40px;">
      <p class="g-pstyle8">PD<span class="g-cstyle1">T</span></p>
    </div>
    <div id="g-ai1-114" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:31.0748%;margin-top:-6.4px;left:61.6492%;width:24px;">
      <p class="g-pstyle9"> </p>
    </div>
    <div id="g-ai1-115" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:31.0748%;margin-top:-6.4px;left:67.0413%;width:40px;">
      <p class="g-pstyle8">PD<span class="g-cstyle1">T</span></p>
    </div>
    <div id="g-ai1-116" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:31.0748%;margin-top:-6.4px;left:72.8653%;width:24px;">
      <p class="g-pstyle9"> </p>
    </div>
    <div id="g-ai1-117" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:31.0748%;margin-top:-6.4px;left:78.2327%;width:40px;">
      <p class="g-pstyle8">PD<span class="g-cstyle1">T</span></p>
    </div>
    <div id="g-ai1-118" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:31.0748%;margin-top:-6.4px;left:84.0564%;width:24px;">
      <p class="g-pstyle9"> </p>
    </div>
    <div id="g-ai1-119" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:31.8569%;margin-top:-8px;left:2.1016%;width:90px;">
      <p class="g-pstyle1">Univ<span class="g-cstyle0">e</span>r<span class="g-cstyle0">s</span>ida<span class="g-cstyle1">d</span></p>
    </div>
    <div id="g-ai1-120" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:31.8938%;margin-top:-6.4px;left:88.1403%;width:44px;">
      <p class="g-pstyle2"> NE<span class="g-cstyle1">M</span></p>
    </div>
    <div id="g-ai1-121" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:31.8938%;margin-top:-6.4px;left:44.4943%;width:41px;">
      <p class="g-pstyle2">len<span class="g-cstyle1">g</span></p>
    </div>
    <div id="g-ai1-122" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:31.8938%;margin-top:-6.4px;left:55.9644%;width:39px;">
      <p class="g-pstyle10"><span class="g-cstyle23">m</span>a<span class="g-cstyle1">t</span></p>
    </div>
    <div id="g-ai1-123" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:31.8938%;margin-top:-6.4px;left:67.0645%;width:41px;">
      <p class="g-pstyle2">cie<span class="g-cstyle1">n</span></p>
    </div>
    <div id="g-ai1-124" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:31.8938%;margin-top:-6.4px;left:78.5806%;width:39px;">
      <p class="g-pstyle2">his<span class="g-cstyle1">t</span></p>
    </div>
    <div id="g-ai1-125" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:33.9638%;margin-top:-7.7px;left:1.9624%;width:87px;">
      <p class="g-pstyle3">PUC de<span class="g-cstyle3"> </span>Ch<span class="g-cstyle3">i</span>le<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-126" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:34.0049%;margin-top:-7.2px;left:44.5642%;width:45px;">
      <p class="g-pstyle4">2<span class="g-cstyle3">0</span>%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-127" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:34.0049%;margin-top:-7.2px;left:55.78%;width:45px;">
      <p class="g-pstyle4">2<span class="g-cstyle3">0</span>%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-128" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:34.0049%;margin-top:-7.2px;left:69.9878%;width:25px;">
      <p class="g-pstyle11"> </p>
    </div>
    <div id="g-ai1-129" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:34.0049%;margin-top:-7.2px;left:78.302%;width:43px;">
      <p class="g-pstyle4">1<span class="g-cstyle3">0</span>%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-130" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:34.0049%;margin-top:-7.2px;left:88.8602%;width:45px;">
      <p class="g-pstyle4">25%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-131" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:35.1105%;margin-top:-7.7px;left:1.9624%;width:75px;">
      <p class="g-pstyle3"><span class="g-cstyle8">U</span>. de C<span class="g-cstyle3">h</span>i<span class="g-cstyle3">le</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-132" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:35.1515%;margin-top:-7.2px;left:44.5871%;width:45px;">
      <p class="g-pstyle4">3<span class="g-cstyle3">0</span>%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-133" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:35.1515%;margin-top:-7.2px;left:56.012%;width:43px;">
      <p class="g-pstyle4">15%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-134" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:35.1515%;margin-top:-7.2px;left:69.9878%;width:25px;">
      <p class="g-pstyle11"> </p>
    </div>
    <div id="g-ai1-135" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:35.1515%;margin-top:-7.2px;left:78.418%;width:43px;">
      <p class="g-pstyle4">15%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-136" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:35.1515%;margin-top:-7.2px;left:88.8834%;width:43px;">
      <p class="g-pstyle4">1<span class="g-cstyle3">0</span>%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-137" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:36.3389%;margin-top:-7.7px;left:1.9624%;width:134px;">
      <p class="g-pstyle3"><span class="g-cstyle8">U</span>. de San<span class="g-cstyle3">ti</span>ago de Chile<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-138" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:36.3799%;margin-top:-7.2px;left:44.5871%;width:45px;">
      <p class="g-pstyle4">3<span class="g-cstyle3">0</span>%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-139" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:36.3799%;margin-top:-7.2px;left:55.9192%;width:43px;">
      <p class="g-pstyle4">1<span class="g-cstyle3">0</span>%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-140" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:36.3799%;margin-top:-7.2px;left:69.9878%;width:25px;">
      <p class="g-pstyle11"> </p>
    </div>
    <div id="g-ai1-141" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:36.3799%;margin-top:-7.2px;left:78.302%;width:43px;">
      <p class="g-pstyle4">1<span class="g-cstyle3">0</span>%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-142" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:36.3799%;margin-top:-7.2px;left:88.8834%;width:43px;">
      <p class="g-pstyle4">1<span class="g-cstyle3">0</span>%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-143" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:37.4855%;margin-top:-7.7px;left:1.9624%;width:107px;">
      <p class="g-pstyle3"><span class="g-cstyle8">U</span>. Ad<span class="g-cstyle3">o</span>lfo<span class="g-cstyle3"> </span>Ibáñez*<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-144" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:37.5265%;margin-top:-7.2px;left:44.6802%;width:45px;">
      <p class="g-pstyle4">25%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-145" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:37.5265%;margin-top:-7.2px;left:56.012%;width:43px;">
      <p class="g-pstyle4">15%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-146" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:37.5265%;margin-top:-7.2px;left:67.1109%;width:43px;">
      <p class="g-pstyle4">1<span class="g-cstyle3">0</span>%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-147" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:37.5265%;margin-top:-7.2px;left:78.302%;width:43px;">
      <p class="g-pstyle4">1<span class="g-cstyle3">0</span>%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-148" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:37.5265%;margin-top:-7.2px;left:88.8834%;width:43px;">
      <p class="g-pstyle4">1<span class="g-cstyle3">0</span>%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-149" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:38.6322%;margin-top:-7.7px;left:1.9624%;width:108px;">
      <p class="g-pstyle3"><span class="g-cstyle8">U</span>. de C<span class="g-cstyle3">o</span>ncepción<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-150" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:38.6731%;margin-top:-7.2px;left:44.5871%;width:45px;">
      <p class="g-pstyle4">3<span class="g-cstyle3">0</span>%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-151" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:38.6731%;margin-top:-7.2px;left:56.012%;width:43px;">
      <p class="g-pstyle4">15%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-152" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:38.6731%;margin-top:-7.2px;left:69.9878%;width:25px;">
      <p class="g-pstyle11"> </p>
    </div>
    <div id="g-ai1-153" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:38.6731%;margin-top:-7.2px;left:78.418%;width:43px;">
      <p class="g-pstyle4">15%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-154" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:38.6731%;margin-top:-7.2px;left:88.9996%;width:43px;">
      <p class="g-pstyle4">15%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-155" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:39.8607%;margin-top:-7.7px;left:1.9624%;width:117px;">
      <p class="g-pstyle3">PUC de<span class="g-cstyle3"> </span><span class="g-cstyle13">V</span>alp<span class="g-cstyle3">a</span>raíso<span class="g-cstyle3">*</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-156" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:39.9017%;margin-top:-7.2px;left:44.5871%;width:45px;">
      <p class="g-pstyle4">3<span class="g-cstyle3">0</span>%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-157" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:39.9017%;margin-top:-7.2px;left:55.78%;width:45px;">
      <p class="g-pstyle4">2<span class="g-cstyle3">0</span>%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-158" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:39.9017%;margin-top:-7.2px;left:67.1109%;width:43px;">
      <p class="g-pstyle4">1<span class="g-cstyle3">0</span>%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-159" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:39.9017%;margin-top:-7.2px;left:78.302%;width:43px;">
      <p class="g-pstyle4">1<span class="g-cstyle3">0</span>%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-160" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:39.9017%;margin-top:-7.2px;left:88.7677%;width:45px;">
      <p class="g-pstyle4">2<span class="g-cstyle3">0</span>%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-161" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:41.0073%;margin-top:-7.7px;left:1.9624%;width:103px;">
      <p class="g-pstyle3"><span class="g-cstyle8">U</span>. de los <span class="g-cstyle3">A</span>ndes*<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-162" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:41.0482%;margin-top:-7.2px;left:44.5178%;width:45px;">
      <p class="g-pstyle4">4<span class="g-cstyle3">0</span>%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-163" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:41.0482%;margin-top:-7.2px;left:55.78%;width:45px;">
      <p class="g-pstyle4">2<span class="g-cstyle3">0</span>%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-164" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:41.0482%;margin-top:-7.2px;left:67.2037%;width:43px;">
      <p class="g-pstyle4">15%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-165" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:41.0482%;margin-top:-7.2px;left:78.418%;width:43px;">
      <p class="g-pstyle4">15%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-166" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:41.0482%;margin-top:-7.2px;left:88.8834%;width:43px;">
      <p class="g-pstyle4">1<span class="g-cstyle3">0</span>%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-167" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:42.2358%;margin-top:-7.7px;left:1.9624%;width:110px;">
      <p class="g-pstyle3"><span class="g-cstyle8">U</span>. Di<span class="g-cstyle3">eg</span>o<span class="g-cstyle3"> </span>P<span class="g-cstyle3">o</span>rtale<span class="g-cstyle3">s</span>*<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-168" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:42.2768%;margin-top:-7.2px;left:44.5871%;width:45px;">
      <p class="g-pstyle4">5<span class="g-cstyle3">0</span>%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-169" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:42.2768%;margin-top:-7.2px;left:55.78%;width:45px;">
      <p class="g-pstyle4">2<span class="g-cstyle3">0</span>%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-170" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:42.2768%;margin-top:-7.2px;left:67.1109%;width:43px;">
      <p class="g-pstyle4">1<span class="g-cstyle3">0</span>%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-171" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:42.2768%;margin-top:-7.2px;left:78.302%;width:43px;">
      <p class="g-pstyle4">1<span class="g-cstyle3">0</span>%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-172" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:42.2768%;margin-top:-7.2px;left:88.8834%;width:43px;">
      <p class="g-pstyle4">1<span class="g-cstyle3">0</span>%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-173" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:43.3824%;margin-top:-7.7px;left:1.9624%;width:140px;">
      <p class="g-pstyle3">UC <span class="g-cstyle3">d</span>e<span class="g-cstyle3"> </span>la<span class="g-cstyle3"> </span>S. C<span class="g-cstyle3">o</span>n<span class="g-cstyle3">c</span>epció<span class="g-cstyle3">n</span>*<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-174" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:43.4234%;margin-top:-7.2px;left:55.9192%;width:43px;">
      <p class="g-pstyle4">1<span class="g-cstyle3">0</span>%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-175" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:43.4234%;margin-top:-7.2px;left:78.302%;width:43px;">
      <p class="g-pstyle4">1<span class="g-cstyle3">0</span>%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-176" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:43.4233%;margin-top:-7.2px;left:44.5642%;width:45px;">
      <p class="g-pstyle4">2<span class="g-cstyle3">0</span>%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-177" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:43.4233%;margin-top:-7.2px;left:67.1109%;width:43px;">
      <p class="g-pstyle4">1<span class="g-cstyle3">0</span>%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-178" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:43.4233%;margin-top:-7.2px;left:88.7677%;width:45px;">
      <p class="g-pstyle4">2<span class="g-cstyle3">0</span>%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-179" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:44.529%;margin-top:-7.7px;left:1.9624%;width:117px;">
      <p class="g-pstyle3"><span class="g-cstyle8">U</span>. Alber<span class="g-cstyle3">t</span>o Hurta<span class="g-cstyle3">d</span>o*<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-180" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:44.57%;margin-top:-7.2px;left:44.5871%;width:45px;">
      <p class="g-pstyle4">3<span class="g-cstyle3">0</span>%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-181" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:44.57%;margin-top:-7.2px;left:56.012%;width:43px;">
      <p class="g-pstyle4">15%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-182" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:44.57%;margin-top:-7.2px;left:67.1109%;width:43px;">
      <p class="g-pstyle4">1<span class="g-cstyle3">0</span>%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-183" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:44.57%;margin-top:-7.2px;left:78.302%;width:43px;">
      <p class="g-pstyle4">1<span class="g-cstyle3">0</span>%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-184" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:44.57%;margin-top:-7.2px;left:88.8834%;width:43px;">
      <p class="g-pstyle4">1<span class="g-cstyle3">0</span>%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-185" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:45.7574%;margin-top:-7.7px;left:1.9624%;width:105px;">
      <p class="g-pstyle3"><span class="g-cstyle8">U</span>. de La <span class="g-cstyle17">F</span><span class="g-cstyle18">r</span>o<span class="g-cstyle3">n</span>tera<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-186" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:45.7984%;margin-top:-7.2px;left:44.5871%;width:45px;">
      <p class="g-pstyle4">3<span class="g-cstyle3">0</span>%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-187" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:45.7984%;margin-top:-7.2px;left:55.78%;width:45px;">
      <p class="g-pstyle4">2<span class="g-cstyle3">0</span>%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-188" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:45.7984%;margin-top:-7.2px;left:69.9878%;width:25px;">
      <p class="g-pstyle11"> </p>
    </div>
    <div id="g-ai1-189" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:45.7984%;margin-top:-7.2px;left:78.302%;width:43px;">
      <p class="g-pstyle4">1<span class="g-cstyle3">0</span>%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-190" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:45.7984%;margin-top:-7.2px;left:88.8834%;width:43px;">
      <p class="g-pstyle4">1<span class="g-cstyle3">0</span>%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-191" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:46.9041%;margin-top:-7.7px;left:1.9624%;width:106px;">
      <p class="g-pstyle3"><span class="g-cstyle8">U</span>. de<span class="g-cstyle3">l</span> De<span class="g-cstyle3">s</span>a<span class="g-cstyle3">r</span><span class="g-cstyle18">r</span><span class="g-cstyle3">o</span>ll<span class="g-cstyle3">o</span>*<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-192" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:46.945%;margin-top:-7.2px;left:44.6802%;width:45px;">
      <p class="g-pstyle4">35%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-193" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:46.945%;margin-top:-7.2px;left:55.8728%;width:45px;">
      <p class="g-pstyle4">35%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-194" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:46.945%;margin-top:-7.2px;left:67.1109%;width:43px;">
      <p class="g-pstyle4">1<span class="g-cstyle3">0</span>%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-195" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:46.945%;margin-top:-7.2px;left:78.302%;width:43px;">
      <p class="g-pstyle4">1<span class="g-cstyle3">0</span>%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-196" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:46.945%;margin-top:-7.2px;left:88.8834%;width:43px;">
      <p class="g-pstyle4">1<span class="g-cstyle3">0</span>%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-197" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:48.1326%;margin-top:-7.7px;left:1.9624%;width:96px;">
      <p class="g-pstyle3"><span class="g-cstyle8">U</span>. Fi<span class="g-cstyle3">n</span>is <span class="g-cstyle20">T</span>erra<span class="g-cstyle3">e</span>*<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-198" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:48.1735%;margin-top:-7.2px;left:44.5178%;width:45px;">
      <p class="g-pstyle4">4<span class="g-cstyle3">0</span>%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-199" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:48.1735%;margin-top:-7.2px;left:55.9192%;width:43px;">
      <p class="g-pstyle4">1<span class="g-cstyle3">0</span>%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-200" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:48.1735%;margin-top:-7.2px;left:67.1109%;width:43px;">
      <p class="g-pstyle4">1<span class="g-cstyle3">0</span>%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-201" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:48.1735%;margin-top:-7.2px;left:78.302%;width:43px;">
      <p class="g-pstyle4">1<span class="g-cstyle3">0</span>%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-202" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:48.1735%;margin-top:-7.2px;left:88.8834%;width:43px;">
      <p class="g-pstyle4">1<span class="g-cstyle3">0</span>%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-203" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:49.2792%;margin-top:-7.7px;left:1.9624%;width:121px;">
      <p class="g-pstyle3"><span class="g-cstyle8">U</span>. C<span class="g-cstyle21">a</span>tólic<span class="g-cstyle3">a</span> del Norte<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-204" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:49.3201%;margin-top:-7.2px;left:44.5871%;width:45px;">
      <p class="g-pstyle4">3<span class="g-cstyle3">0</span>%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-205" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:49.3201%;margin-top:-7.2px;left:55.9192%;width:43px;">
      <p class="g-pstyle4">1<span class="g-cstyle3">0</span>%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-206" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:49.3201%;margin-top:-7.2px;left:69.9878%;width:25px;">
      <p class="g-pstyle11"> </p>
    </div>
    <div id="g-ai1-207" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:49.3201%;margin-top:-7.2px;left:78.302%;width:43px;">
      <p class="g-pstyle4">1<span class="g-cstyle3">0</span>%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-208" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:49.3201%;margin-top:-7.2px;left:88.7677%;width:45px;">
      <p class="g-pstyle4">2<span class="g-cstyle3">0</span>%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-209" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:50.4258%;margin-top:-7.7px;left:1.9624%;width:99px;">
      <p class="g-pstyle3"><span class="g-cstyle8">U</span>. de La <span class="g-cstyle3">Se</span><span class="g-cstyle18">r</span>ena<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-210" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:50.4667%;margin-top:-7.2px;left:44.5871%;width:45px;">
      <p class="g-pstyle4">3<span class="g-cstyle3">0</span>%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-211" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:50.4667%;margin-top:-7.2px;left:55.9192%;width:43px;">
      <p class="g-pstyle4">1<span class="g-cstyle3">0</span>%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-212" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:50.4667%;margin-top:-7.2px;left:69.9878%;width:25px;">
      <p class="g-pstyle11"> </p>
    </div>
    <div id="g-ai1-213" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:50.4667%;margin-top:-7.2px;left:78.1863%;width:45px;">
      <p class="g-pstyle4">3<span class="g-cstyle3">0</span>%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-214" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:50.4667%;margin-top:-7.2px;left:88.7677%;width:45px;">
      <p class="g-pstyle4">2<span class="g-cstyle3">0</span>%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-215" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:51.6543%;margin-top:-7.7px;left:1.9624%;width:117px;">
      <p class="g-pstyle3"><span class="g-cstyle8">U</span>. Ce<span class="g-cstyle3">nt</span>r<span class="g-cstyle3">a</span>l<span class="g-cstyle3"> </span>de Chi<span class="g-cstyle3">l</span>e*<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-216" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:51.6952%;margin-top:-7.2px;left:44.5178%;width:45px;">
      <p class="g-pstyle4">4<span class="g-cstyle3">0</span>%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-217" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:51.6952%;margin-top:-7.2px;left:55.9192%;width:43px;">
      <p class="g-pstyle4">1<span class="g-cstyle3">0</span>%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-218" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:51.6952%;margin-top:-7.2px;left:67.1109%;width:43px;">
      <p class="g-pstyle4">1<span class="g-cstyle3">0</span>%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-219" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:51.6952%;margin-top:-7.2px;left:78.302%;width:43px;">
      <p class="g-pstyle4">1<span class="g-cstyle3">0</span>%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-220" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:51.6952%;margin-top:-7.2px;left:88.8834%;width:43px;">
      <p class="g-pstyle4">1<span class="g-cstyle3">0</span>%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-221" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:52.8009%;margin-top:-7.7px;left:1.9624%;width:119px;">
      <p class="g-pstyle3"><span class="g-cstyle8">U</span>. de Las<span class="g-cstyle3"> </span>América<span class="g-cstyle3">s</span>*<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-222" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:52.8418%;margin-top:-7.2px;left:78.302%;width:43px;">
      <p class="g-pstyle4">1<span class="g-cstyle3">0</span>%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-223" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:52.8418%;margin-top:-7.2px;left:44.7031%;width:43px;">
      <p class="g-pstyle4">1<span class="g-cstyle3">0</span>%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-224" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:52.8418%;margin-top:-7.2px;left:55.9192%;width:43px;">
      <p class="g-pstyle4">1<span class="g-cstyle3">0</span>%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-225" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:52.8418%;margin-top:-7.2px;left:67.1109%;width:43px;">
      <p class="g-pstyle4">1<span class="g-cstyle3">0</span>%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-226" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:52.8418%;margin-top:-7.2px;left:88.7677%;width:45px;">
      <p class="g-pstyle4">3<span class="g-cstyle3">0</span>%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-227" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:54.0294%;margin-top:-7.7px;left:1.9624%;width:101px;">
      <p class="g-pstyle3"><span class="g-cstyle8">U</span>. An<span class="g-cstyle3">d</span><span class="g-cstyle18">r</span>és <span class="g-cstyle3">B</span>ello<span class="g-cstyle3">*</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-228" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:54.0703%;margin-top:-7.2px;left:44.6802%;width:45px;">
      <p class="g-pstyle4">35%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-229" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:54.0703%;margin-top:-7.2px;left:56.012%;width:43px;">
      <p class="g-pstyle4">15%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-230" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:54.0703%;margin-top:-7.2px;left:66.9946%;width:45px;">
      <p class="g-pstyle4">3<span class="g-cstyle3">0</span>%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-231" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:54.0703%;margin-top:-7.2px;left:78.1863%;width:45px;">
      <p class="g-pstyle4">3<span class="g-cstyle3">0</span>%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-232" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:54.0703%;margin-top:-7.2px;left:88.8834%;width:43px;">
      <p class="g-pstyle4">1<span class="g-cstyle3">0</span>%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-233" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:55.176%;margin-top:-7.7px;left:1.9624%;width:132px;">
      <p class="g-pstyle3"><span class="g-cstyle8">U</span>. Be<span class="g-cstyle3">r</span>nard<span class="g-cstyle3">o</span> O&rsquo;Higgins*<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-234" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:55.2169%;margin-top:-7.2px;left:44.6802%;width:45px;">
      <p class="g-pstyle4">25%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-235" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:55.2169%;margin-top:-7.2px;left:55.9192%;width:43px;">
      <p class="g-pstyle4">1<span class="g-cstyle3">0</span>%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-236" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:55.2169%;margin-top:-7.2px;left:67.2037%;width:43px;">
      <p class="g-pstyle4">15%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-237" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:55.2169%;margin-top:-7.2px;left:78.418%;width:43px;">
      <p class="g-pstyle4">15%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-238" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:55.2169%;margin-top:-7.2px;left:88.8602%;width:45px;">
      <p class="g-pstyle4">25%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-239" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:56.3226%;margin-top:-7.7px;left:1.9624%;width:131px;">
      <p class="g-pstyle3"><span class="g-cstyle8">U</span>. Aut<span class="g-cstyle3">ó</span>n<span class="g-cstyle3">o</span>m<span class="g-cstyle3">a</span> de Ch<span class="g-cstyle3">i</span>le*<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-240" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:56.4454%;margin-top:-7.2px;left:44.5871%;width:45px;">
      <p class="g-pstyle4">3<span class="g-cstyle3">0</span>%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-241" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:56.4454%;margin-top:-7.2px;left:55.78%;width:45px;">
      <p class="g-pstyle4">2<span class="g-cstyle3">0</span>%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-242" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:56.4454%;margin-top:-7.2px;left:67.1109%;width:43px;">
      <p class="g-pstyle4">1<span class="g-cstyle3">0</span>%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-243" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:56.4454%;margin-top:-7.2px;left:78.302%;width:43px;">
      <p class="g-pstyle4">1<span class="g-cstyle3">0</span>%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-244" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:56.4454%;margin-top:-7.2px;left:88.8834%;width:43px;">
      <p class="g-pstyle4">1<span class="g-cstyle3">0</span>%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-245" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:57.5511%;margin-top:-7.7px;left:1.9624%;width:108px;">
      <p class="g-pstyle3"><span class="g-cstyle8">U</span>. Au<span class="g-cstyle3">s</span>tral<span class="g-cstyle3"> </span>de Chi<span class="g-cstyle3">l</span><span class="g-cstyle1">e</span></p>
    </div>
    <div id="g-ai1-246" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:57.592%;margin-top:-7.2px;left:44.6802%;width:45px;">
      <p class="g-pstyle4">25%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-247" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:57.592%;margin-top:-7.2px;left:55.9192%;width:41px;">
      <p class="g-pstyle6"><span class="g-cstyle12">1</span>0<span class="g-cstyle1">%</span></p>
    </div>
    <div id="g-ai1-248" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:57.592%;margin-top:-7.2px;left:67.1109%;width:43px;">
      <p class="g-pstyle4">1<span class="g-cstyle3">0</span>%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-249" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:57.592%;margin-top:-7.2px;left:78.418%;width:43px;">
      <p class="g-pstyle4">15%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-250" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:57.592%;margin-top:-7.2px;left:88.8834%;width:41px;">
      <p class="g-pstyle6"><span class="g-cstyle12">1</span>0<span class="g-cstyle1">%</span></p>
    </div>
    <div id="g-ai1-251" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:60.3132%;margin-top:-6.4px;left:50.4117%;width:60px;">
      <p class="g-pstyle10">Ra<span class="g-cstyle23">n</span>k<span class="g-cstyle23">in</span>g<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-252" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:60.3132%;margin-top:-6.4px;left:83.8553%;width:58px;">
      <p class="g-pstyle2"><span class="g-cstyle0">A</span>rancel<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-253" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:61.0953%;margin-top:-8px;left:2.1016%;width:90px;">
      <p class="g-pstyle1">Univ<span class="g-cstyle0">e</span>r<span class="g-cstyle0">s</span>ida<span class="g-cstyle1">d</span></p>
    </div>
    <div id="g-ai1-254" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:61.1322%;margin-top:-6.4px;left:63.6664%;width:64px;">
      <p class="g-pstyle10">Va<span class="g-cstyle23">c</span>a<span class="g-cstyle23">n</span>te<span class="g-cstyle1">s</span></p>
    </div>
    <div id="g-ai1-255" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:61.1322%;margin-top:-6.4px;left:52.2449%;width:47px;">
      <p class="g-pstyle2">not<span class="g-cstyle0">a</span><span class="g-cstyle1">s</span></p>
    </div>
    <div id="g-ai1-256" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:61.1322%;margin-top:-6.4px;left:79.6323%;width:70px;">
      <p class="g-pstyle2">referen<span class="g-cstyle0">c</span>ia<span class="g-cstyle1">l</span></p>
    </div>
    <div id="g-ai1-257" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:63.2021%;margin-top:-7.7px;left:1.9624%;width:87px;">
      <p class="g-pstyle3">PUC de<span class="g-cstyle3"> </span>Ch<span class="g-cstyle3">i</span>le<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-258" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:63.2432%;margin-top:-7.2px;left:53.0798%;width:45px;">
      <p class="g-pstyle5"><span class="g-cstyle3">2</span>5%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-259" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:63.2432%;margin-top:-7.2px;left:67.5381%;width:42px;">
      <p class="g-pstyle5">1<span class="g-cstyle3">2</span>5<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-260" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:63.2432%;margin-top:-7.2px;left:78.2199%;width:83px;">
      <p class="g-pstyle5"><span class="g-cstyle3">$</span>5<span class="g-cstyle3">.</span>588<span class="g-cstyle11">.</span><span class="g-cstyle3">0</span>00<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-261" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:64.3488%;margin-top:-7.7px;left:1.9624%;width:75px;">
      <p class="g-pstyle3"><span class="g-cstyle8">U</span>. de C<span class="g-cstyle3">h</span>i<span class="g-cstyle3">le</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-262" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:64.3898%;margin-top:-7.2px;left:53.0106%;width:46px;">
      <p class="g-pstyle5">30%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-263" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:64.3898%;margin-top:-7.2px;left:67.5381%;width:41px;">
      <p class="g-pstyle5">11<span class="g-cstyle3">0</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-264" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:64.3898%;margin-top:-7.2px;left:78.5681%;width:82px;">
      <p class="g-pstyle5"><span class="g-cstyle3">$</span>3<span class="g-cstyle11">.</span>755<span class="g-cstyle3">.</span>80<span class="g-cstyle3">0</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-265" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:65.5773%;margin-top:-7.7px;left:1.9624%;width:134px;">
      <p class="g-pstyle3"><span class="g-cstyle8">U</span>. de San<span class="g-cstyle3">ti</span>ago de Chile<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-266" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:65.6182%;margin-top:-7.2px;left:52.9178%;width:46px;">
      <p class="g-pstyle5">4<span class="g-cstyle3">0</span>%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-267" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:65.6182%;margin-top:-7.2px;left:68.3502%;width:37px;">
      <p class="g-pstyle5">65<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-268" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:65.6182%;margin-top:-7.2px;left:78.2663%;width:83px;">
      <p class="g-pstyle5"><span class="g-cstyle3">$</span>3<span class="g-cstyle3">.</span>545<span class="g-cstyle17">.</span>0<span class="g-cstyle3">0</span>0<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-269" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:66.7239%;margin-top:-7.7px;left:1.9624%;width:107px;">
      <p class="g-pstyle3"><span class="g-cstyle8">U</span>. Ad<span class="g-cstyle3">o</span>lfo<span class="g-cstyle3"> </span>Ibáñez*<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-270" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:66.7648%;margin-top:-7.2px;left:52.9178%;width:46px;">
      <p class="g-pstyle5">4<span class="g-cstyle3">0</span>%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-271" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:66.7648%;margin-top:-7.2px;left:68.3734%;width:37px;">
      <p class="g-pstyle5"><span class="g-cstyle3">2</span>5<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-272" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:66.7648%;margin-top:-7.2px;left:84.6469%;width:57px;">
      <p class="g-pstyle5">19<span class="g-cstyle3">0</span> <span class="g-cstyle3">U</span>F<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-273" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:67.8705%;margin-top:-7.7px;left:1.9624%;width:108px;">
      <p class="g-pstyle3"><span class="g-cstyle8">U</span>. de C<span class="g-cstyle3">o</span>ncepción<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-274" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:67.9114%;margin-top:-7.2px;left:53.0798%;width:45px;">
      <p class="g-pstyle5"><span class="g-cstyle3">2</span>5%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-275" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:67.9114%;margin-top:-7.2px;left:68.3273%;width:37px;">
      <p class="g-pstyle7"><span class="g-cstyle12">5</span>0<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-276" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:67.9114%;margin-top:-7.2px;left:78.2425%;width:82px;">
      <p class="g-pstyle5"><span class="g-cstyle3">$</span>4<span class="g-cstyle3">.</span>2<span class="g-cstyle3">4</span>4.<span class="g-cstyle3">5</span>65<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-277" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:69.099%;margin-top:-7.7px;left:1.9624%;width:117px;">
      <p class="g-pstyle3">PUC de<span class="g-cstyle3"> </span><span class="g-cstyle13">V</span>alp<span class="g-cstyle3">a</span>raíso<span class="g-cstyle3">*</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-278" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:69.14%;margin-top:-7.2px;left:52.9874%;width:46px;">
      <p class="g-pstyle5"><span class="g-cstyle3">2</span>0%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-279" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:69.14%;margin-top:-7.2px;left:68.2571%;width:38px;">
      <p class="g-pstyle5">80<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-280" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:69.14%;margin-top:-7.2px;left:78.1964%;width:83px;">
      <p class="g-pstyle5"><span class="g-cstyle3">$</span>3<span class="g-cstyle11">.</span>93<span class="g-cstyle17">0</span><span class="g-cstyle11">.</span><span class="g-cstyle3">0</span>00<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-281" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:70.2456%;margin-top:-7.7px;left:1.9624%;width:103px;">
      <p class="g-pstyle3"><span class="g-cstyle8">U</span>. de los <span class="g-cstyle3">A</span>ndes*<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-282" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:70.2865%;margin-top:-7.2px;left:53.1494%;width:44px;">
      <p class="g-pstyle5">15%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-283" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:70.2865%;margin-top:-7.2px;left:68.3273%;width:37px;">
      <p class="g-pstyle5">47<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-284" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:70.2865%;margin-top:-7.2px;left:84.856%;width:56px;">
      <p class="g-pstyle5">178<span class="g-cstyle3"> </span>U<span class="g-cstyle3">F</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-285" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:71.4741%;margin-top:-7.7px;left:1.9624%;width:110px;">
      <p class="g-pstyle3"><span class="g-cstyle8">U</span>. Di<span class="g-cstyle3">eg</span>o<span class="g-cstyle3"> </span>P<span class="g-cstyle3">o</span>rtale<span class="g-cstyle3">s</span>*<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-286" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:71.5151%;margin-top:-7.2px;left:53.0569%;width:44px;">
      <p class="g-pstyle5">1<span class="g-cstyle3">0</span>%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-287" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:71.5151%;margin-top:-7.2px;left:67.5146%;width:42px;">
      <p class="g-pstyle5">136<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-288" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:71.5151%;margin-top:-7.2px;left:78.2193%;width:83px;">
      <p class="g-pstyle5"><span class="g-cstyle3">$</span>5<span class="g-cstyle3">.</span>45<span class="g-cstyle3">2</span><span class="g-cstyle11">.</span><span class="g-cstyle3">0</span>00<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-289" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:72.6207%;margin-top:-7.7px;left:1.9624%;width:140px;">
      <p class="g-pstyle3">UC <span class="g-cstyle3">d</span>e<span class="g-cstyle3"> </span>la<span class="g-cstyle3"> </span>S. C<span class="g-cstyle3">o</span>n<span class="g-cstyle3">c</span>epció<span class="g-cstyle3">n</span>*<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-290" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:72.6617%;margin-top:-7.2px;left:52.9178%;width:46px;">
      <p class="g-pstyle5">4<span class="g-cstyle3">0</span>%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-291" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:72.6616%;margin-top:-7.2px;left:68.3966%;width:37px;">
      <p class="g-pstyle5">55<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-292" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:72.6616%;margin-top:-7.2px;left:78.1265%;width:83px;">
      <p class="g-pstyle5"><span class="g-cstyle3">$</span>3<span class="g-cstyle3">.</span>50<span class="g-cstyle17">0</span><span class="g-cstyle11">.</span>0<span class="g-cstyle3">0</span>0<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-293" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:73.7673%;margin-top:-7.7px;left:1.9624%;width:117px;">
      <p class="g-pstyle3"><span class="g-cstyle8">U</span>. Alber<span class="g-cstyle3">t</span>o Hurta<span class="g-cstyle3">d</span>o*<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-294" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:73.8083%;margin-top:-7.2px;left:53.1033%;width:46px;">
      <p class="g-pstyle5">35%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-295" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:73.8083%;margin-top:-7.2px;left:68.3502%;width:37px;">
      <p class="g-pstyle5">70<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-296" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:73.8083%;margin-top:-7.2px;left:78.475%;width:82px;">
      <p class="g-pstyle7">$<span class="g-cstyle12">5</span><span class="g-cstyle17">.</span><span class="g-cstyle12">0</span>2<span class="g-cstyle24">7</span><span class="g-cstyle11">.</span>0<span class="g-cstyle12">0</span>0<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-297" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:74.9958%;margin-top:-7.7px;left:1.9624%;width:105px;">
      <p class="g-pstyle3"><span class="g-cstyle8">U</span>. de La <span class="g-cstyle17">F</span><span class="g-cstyle18">r</span>o<span class="g-cstyle3">n</span>tera<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-298" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:75.0367%;margin-top:-7.2px;left:53.0106%;width:46px;">
      <p class="g-pstyle5">30%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-299" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:75.0367%;margin-top:-7.2px;left:68.3734%;width:37px;">
      <p class="g-pstyle5"><span class="g-cstyle3">2</span>5<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-300" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:75.0367%;margin-top:-7.2px;left:78.4979%;width:81px;">
      <p class="g-pstyle5"><span class="g-cstyle3">$</span>3<span class="g-cstyle3">.</span>2<span class="g-cstyle3">1</span>5<span class="g-cstyle11">.</span><span class="g-cstyle3">0</span>00<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-301" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:76.1424%;margin-top:-7.7px;left:1.9624%;width:106px;">
      <p class="g-pstyle3"><span class="g-cstyle8">U</span>. de<span class="g-cstyle3">l</span> De<span class="g-cstyle3">s</span>a<span class="g-cstyle3">r</span><span class="g-cstyle18">r</span><span class="g-cstyle3">o</span>ll<span class="g-cstyle3">o</span>*<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-302" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:76.1834%;margin-top:-7.2px;left:53.0569%;width:44px;">
      <p class="g-pstyle5">1<span class="g-cstyle3">0</span>%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-303" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:76.1834%;margin-top:-7.2px;left:68.3966%;width:37px;">
      <p class="g-pstyle5">55<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-304" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:76.1834%;margin-top:-7.2px;left:84.8096%;width:56px;">
      <p class="g-pstyle5"><span class="g-cstyle3">2</span>2<span class="g-cstyle3">1</span> <span class="g-cstyle3">U</span>F<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-305" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:77.3709%;margin-top:-7.7px;left:1.9624%;width:96px;">
      <p class="g-pstyle3"><span class="g-cstyle8">U</span>. Fi<span class="g-cstyle3">n</span>is <span class="g-cstyle20">T</span>erra<span class="g-cstyle3">e</span>*<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-306" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:77.4119%;margin-top:-7.2px;left:53.0106%;width:46px;">
      <p class="g-pstyle5">30%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-307" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:77.4119%;margin-top:-7.2px;left:68.2571%;width:38px;">
      <p class="g-pstyle5">90<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-308" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:77.4119%;margin-top:-7.2px;left:77.9413%;width:83px;">
      <p class="g-pstyle5"><span class="g-cstyle3">$</span>4<span class="g-cstyle3">.</span>54<span class="g-cstyle17">0</span><span class="g-cstyle11">.</span>0<span class="g-cstyle3">0</span>0<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-309" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:78.5175%;margin-top:-7.7px;left:1.9624%;width:121px;">
      <p class="g-pstyle3"><span class="g-cstyle8">U</span>. C<span class="g-cstyle21">a</span>tólic<span class="g-cstyle3">a</span> del Norte<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-310" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:78.5585%;margin-top:-7.2px;left:53.0106%;width:46px;">
      <p class="g-pstyle5">30%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-311" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:78.5585%;margin-top:-7.2px;left:68.3734%;width:37px;">
      <p class="g-pstyle7"><span class="g-cstyle12">3</span>2<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-312" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:78.5585%;margin-top:-7.2px;left:78.15%;width:83px;">
      <p class="g-pstyle5"><span class="g-cstyle3">$</span>3<span class="g-cstyle3">.</span>495<span class="g-cstyle17">.</span>00<span class="g-cstyle3">0</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-313" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:79.6641%;margin-top:-7.7px;left:1.9624%;width:99px;">
      <p class="g-pstyle3"><span class="g-cstyle8">U</span>. de La <span class="g-cstyle3">Se</span><span class="g-cstyle18">r</span>ena<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-314" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:79.7051%;margin-top:-7.2px;left:53.0569%;width:44px;">
      <p class="g-pstyle5">1<span class="g-cstyle3">0</span>%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-315" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:79.7051%;margin-top:-7.2px;left:68.3273%;width:37px;">
      <p class="g-pstyle7"><span class="g-cstyle12">5</span>0<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-316" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:79.7051%;margin-top:-7.2px;left:78.6371%;width:79px;">
      <p class="g-pstyle5"><span class="g-cstyle3">$</span>3<span class="g-cstyle3">.</span>113<span class="g-cstyle17">.</span>00<span class="g-cstyle3">0</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-317" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:80.8926%;margin-top:-7.7px;left:1.9624%;width:117px;">
      <p class="g-pstyle3"><span class="g-cstyle8">U</span>. Ce<span class="g-cstyle3">nt</span>r<span class="g-cstyle3">a</span>l<span class="g-cstyle3"> </span>de Chi<span class="g-cstyle3">l</span>e*<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-318" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:80.9336%;margin-top:-7.2px;left:53.0106%;width:46px;">
      <p class="g-pstyle5">30%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-319" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:80.9336%;margin-top:-7.2px;left:68.3273%;width:37px;">
      <p class="g-pstyle7"><span class="g-cstyle12">5</span>0<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-320" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:80.9336%;margin-top:-7.2px;left:78.0804%;width:83px;">
      <p class="g-pstyle5"><span class="g-cstyle3">$</span>3<span class="g-cstyle3">.</span>824<span class="g-cstyle17">.</span>0<span class="g-cstyle3">0</span>0<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-321" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:82.0392%;margin-top:-7.7px;left:1.9624%;width:119px;">
      <p class="g-pstyle3"><span class="g-cstyle8">U</span>. de Las<span class="g-cstyle3"> </span>América<span class="g-cstyle3">s</span>*<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-322" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:82.0802%;margin-top:-7.2px;left:52.9178%;width:46px;">
      <p class="g-pstyle5">4<span class="g-cstyle3">0</span>%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-323" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:82.0802%;margin-top:-7.2px;left:68.3035%;width:38px;">
      <p class="g-pstyle5">30<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-324" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:82.0802%;margin-top:-7.2px;left:78.5678%;width:80px;">
      <p class="g-pstyle5"><span class="g-cstyle3">$</span>3<span class="g-cstyle11">.</span>7<span class="g-cstyle3">2</span>1<span class="g-cstyle11">.</span><span class="g-cstyle3">0</span>00<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-325" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:83.2677%;margin-top:-7.7px;left:1.9624%;width:101px;">
      <p class="g-pstyle3"><span class="g-cstyle8">U</span>. An<span class="g-cstyle3">d</span><span class="g-cstyle18">r</span>és <span class="g-cstyle3">B</span>ello<span class="g-cstyle3">*</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-326" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:83.3087%;margin-top:-7.2px;left:53.0569%;width:44px;">
      <p class="g-pstyle5">1<span class="g-cstyle3">0</span>%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-327" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:83.3087%;margin-top:-7.2px;left:68.3502%;width:37px;">
      <p class="g-pstyle5">85<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-328" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:83.3087%;margin-top:-7.2px;left:78.1036%;width:83px;">
      <p class="g-pstyle5"><span class="g-cstyle3">$</span>5<span class="g-cstyle3">.</span>49<span class="g-cstyle3">2</span><span class="g-cstyle11">.</span><span class="g-cstyle3">0</span>00<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-329" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:84.4143%;margin-top:-7.7px;left:1.9624%;width:132px;">
      <p class="g-pstyle3"><span class="g-cstyle8">U</span>. Be<span class="g-cstyle3">r</span>nard<span class="g-cstyle3">o</span> O&rsquo;Higgins*<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-330" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:84.4553%;margin-top:-7.2px;left:53.0798%;width:45px;">
      <p class="g-pstyle5"><span class="g-cstyle3">2</span>5%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-331" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:84.4553%;margin-top:-7.2px;left:68.2803%;width:37px;">
      <p class="g-pstyle5"><span class="g-cstyle3">2</span>0<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-332" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:84.4553%;margin-top:-7.2px;left:78.1036%;width:83px;">
      <p class="g-pstyle5"><span class="g-cstyle3">$</span>3<span class="g-cstyle3">.</span>34<span class="g-cstyle11">0</span><span class="g-cstyle17">.</span>0<span class="g-cstyle3">0</span>0<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-333" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:85.5609%;margin-top:-7.7px;left:1.9624%;width:131px;">
      <p class="g-pstyle3"><span class="g-cstyle8">U</span>. Aut<span class="g-cstyle3">ó</span>n<span class="g-cstyle3">o</span>m<span class="g-cstyle3">a</span> de Ch<span class="g-cstyle3">i</span>le*<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-334" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:85.6838%;margin-top:-7.2px;left:53.0106%;width:46px;">
      <p class="g-pstyle5">30%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-335" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:85.6838%;margin-top:-7.2px;left:68.3273%;width:37px;">
      <p class="g-pstyle7"><span class="g-cstyle12">5</span>0<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-336" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:85.6838%;margin-top:-7.2px;left:78.3127%;width:81px;">
      <p class="g-pstyle5"><span class="g-cstyle3">$</span>4<span class="g-cstyle3">.</span>2<span class="g-cstyle3">1</span>3<span class="g-cstyle11">.</span><span class="g-cstyle3">0</span>00<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-337" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:86.7894%;margin-top:-7.7px;left:1.9624%;width:108px;">
      <p class="g-pstyle3"><span class="g-cstyle8">U</span>. Au<span class="g-cstyle3">s</span>tral<span class="g-cstyle3"> </span>de Chi<span class="g-cstyle3">l</span><span class="g-cstyle1">e</span></p>
    </div>
    <div id="g-ai1-338" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:86.8304%;margin-top:-7.2px;left:52.9178%;width:46px;">
      <p class="g-pstyle5">4<span class="g-cstyle3">0</span>%<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-339" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:86.8304%;margin-top:-7.2px;left:68.2803%;width:35px;">
      <p class="g-pstyle12"><span class="g-cstyle12">4</span>2</p>
    </div>
    <div id="g-ai1-340" class="g-Layer_1 g-aiAbs g-aiPointText" style="top:86.8304%;margin-top:-7.2px;left:78.1729%;width:81px;">
      <p class="g-pstyle5"><span class="g-cstyle3">$</span>3<span class="g-cstyle3">.</span>298<span class="g-cstyle17">.</span>0<span class="g-cstyle3">0</span><span class="g-cstyle1">0</span></p>
    </div>
    <div id="g-ai1-341" class="g-Layer_1 g-aiAbs" style="top:88.3702%;left:4.375%;width:91.5625%;">
      <p>Fuente: Información proporcionada por cada casa de estudio, la cual corresponde a la jornada diurna / En algunos casos los aranceles y vacantes corresponden al año 2021 / (*) Piden una de las dos pruebas optativas / La información de la U. de Santiago de Chile fue extraída de su portal (www.usach.cl), donde se señala que los puntajes de ingreso corresponden al último seleccionado y los aranceles a los deciles 7, 8 y 9 / La UNIACC &mdash;Santiago, 50 vacantes vespertino, $2.950.000, y 40 semipresencial, $2.590.000&mdash;, no considera los resultados de la PDT en su proceso de selección</p>
    </div>
  </div>


</div>
`

const containerId = 'g-periodismo-box'
const namespace = 'g-'
const name = 'periodismo'

export default makeAi2React({ html, styles, containerId, namespace, name })

/* End ai2react - 2021-12-18 13:42 */
